var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _c("div", [
      _c("div", { staticClass: "wrapper-table" }, [
        _c("table", { staticClass: "table-data", attrs: { border: "" } }, [
          _vm._m(0),
          _c("tbody", [
            _c("tr", [
              _c("td", { staticClass: "table-index" }, [_vm._v("1")]),
              _c("td", [_vm._v("Có cần duyệt album ảnh hay không?")]),
              _c(
                "td",
                { staticClass: "table-action" },
                [
                  _c(
                    "el-radio-group",
                    {
                      model: {
                        value: _vm.schoolConfigInSysResponse.album,
                        callback: function ($$v) {
                          _vm.$set(_vm.schoolConfigInSysResponse, "album", $$v)
                        },
                        expression: "schoolConfigInSysResponse.album",
                      },
                    },
                    [
                      _c("el-radio", { attrs: { label: false } }, [
                        _vm._v("Có"),
                      ]),
                      _c("el-radio", { attrs: { label: true } }, [
                        _vm._v("Không"),
                      ]),
                    ],
                    1
                  ),
                ],
                1
              ),
            ]),
            _c("tr", [
              _c("td", { staticClass: "table-index" }, [_vm._v("2")]),
              _c("td", [_vm._v("Có cần duyệt đánh giá nhận xét hay không?")]),
              _c(
                "td",
                { staticClass: "table-action" },
                [
                  _c(
                    "el-radio-group",
                    {
                      model: {
                        value: _vm.schoolConfigInSysResponse.evaluate,
                        callback: function ($$v) {
                          _vm.$set(
                            _vm.schoolConfigInSysResponse,
                            "evaluate",
                            $$v
                          )
                        },
                        expression: "schoolConfigInSysResponse.evaluate",
                      },
                    },
                    [
                      _c("el-radio", { attrs: { label: false } }, [
                        _vm._v("Có"),
                      ]),
                      _c("el-radio", { attrs: { label: true } }, [
                        _vm._v("Không"),
                      ]),
                    ],
                    1
                  ),
                ],
                1
              ),
            ]),
            _c("tr", [
              _c("td", { staticClass: "table-index" }, [_vm._v("3")]),
              _c("td", [
                _vm._v("Có cho phép sửa đánh giá khi đã duyệt hay không?"),
              ]),
              _c(
                "td",
                { staticClass: "table-action" },
                [
                  _c(
                    "el-radio-group",
                    {
                      model: {
                        value: _vm.schoolConfigInSysResponse.editAproved,
                        callback: function ($$v) {
                          _vm.$set(
                            _vm.schoolConfigInSysResponse,
                            "editAproved",
                            $$v
                          )
                        },
                        expression: "schoolConfigInSysResponse.editAproved",
                      },
                    },
                    [
                      _c("el-radio", { attrs: { label: true } }, [
                        _vm._v("Có"),
                      ]),
                      _c("el-radio", { attrs: { label: false } }, [
                        _vm._v("Không"),
                      ]),
                    ],
                    1
                  ),
                ],
                1
              ),
            ]),
            _c("tr", [
              _c("td", { staticClass: "table-index" }, [_vm._v("4")]),
              _c("td", [
                _vm._v("Có hiển thị chức năng đánh giá ngày hay không?"),
              ]),
              _c(
                "td",
                { staticClass: "table-action" },
                [
                  _c(
                    "el-radio-group",
                    {
                      model: {
                        value: _vm.schoolConfigInSysResponse.evaluateDate,
                        callback: function ($$v) {
                          _vm.$set(
                            _vm.schoolConfigInSysResponse,
                            "evaluateDate",
                            $$v
                          )
                        },
                        expression: "schoolConfigInSysResponse.evaluateDate",
                      },
                    },
                    [
                      _c("el-radio", { attrs: { label: true } }, [
                        _vm._v("Có"),
                      ]),
                      _c("el-radio", { attrs: { label: false } }, [
                        _vm._v("Không"),
                      ]),
                    ],
                    1
                  ),
                ],
                1
              ),
            ]),
            _c("tr", [
              _c("td", { staticClass: "table-index" }, [_vm._v("5")]),
              _c("td", [
                _vm._v("Có hiển thị chức năng đánh giá tuần hay không?"),
              ]),
              _c(
                "td",
                { staticClass: "table-action" },
                [
                  _c(
                    "el-radio-group",
                    {
                      model: {
                        value: _vm.schoolConfigInSysResponse.evaluateWeek,
                        callback: function ($$v) {
                          _vm.$set(
                            _vm.schoolConfigInSysResponse,
                            "evaluateWeek",
                            $$v
                          )
                        },
                        expression: "schoolConfigInSysResponse.evaluateWeek",
                      },
                    },
                    [
                      _c("el-radio", { attrs: { label: true } }, [
                        _vm._v("Có"),
                      ]),
                      _c("el-radio", { attrs: { label: false } }, [
                        _vm._v("Không"),
                      ]),
                    ],
                    1
                  ),
                ],
                1
              ),
            ]),
            _c("tr", [
              _c("td", { staticClass: "table-index" }, [_vm._v("6")]),
              _c("td", [
                _vm._v("Có hiển thị chức năng đánh giá tháng hay không?"),
              ]),
              _c(
                "td",
                { staticClass: "table-action" },
                [
                  _c(
                    "el-radio-group",
                    {
                      model: {
                        value: _vm.schoolConfigInSysResponse.evaluateMonth,
                        callback: function ($$v) {
                          _vm.$set(
                            _vm.schoolConfigInSysResponse,
                            "evaluateMonth",
                            $$v
                          )
                        },
                        expression: "schoolConfigInSysResponse.evaluateMonth",
                      },
                    },
                    [
                      _c("el-radio", { attrs: { label: true } }, [
                        _vm._v("Có"),
                      ]),
                      _c("el-radio", { attrs: { label: false } }, [
                        _vm._v("Không"),
                      ]),
                    ],
                    1
                  ),
                ],
                1
              ),
            ]),
            _c("tr", [
              _c("td", { staticClass: "table-index" }, [_vm._v("7")]),
              _c("td", [
                _vm._v("Có hiển thị chức năng đánh giá định kỳ hay không?"),
              ]),
              _c(
                "td",
                { staticClass: "table-action" },
                [
                  _c(
                    "el-radio-group",
                    {
                      model: {
                        value: _vm.schoolConfigInSysResponse.evaluatePeriod,
                        callback: function ($$v) {
                          _vm.$set(
                            _vm.schoolConfigInSysResponse,
                            "evaluatePeriod",
                            $$v
                          )
                        },
                        expression: "schoolConfigInSysResponse.evaluatePeriod",
                      },
                    },
                    [
                      _c("el-radio", { attrs: { label: true } }, [
                        _vm._v("Có"),
                      ]),
                      _c("el-radio", { attrs: { label: false } }, [
                        _vm._v("Không"),
                      ]),
                    ],
                    1
                  ),
                ],
                1
              ),
            ]),
            _c("tr", [
              _c("td", { staticClass: "table-index" }, [_vm._v("8")]),
              _c("td", [_vm._v("Có gửi thông báo điểm danh đến hay không?")]),
              _c(
                "td",
                { staticClass: "table-action" },
                [
                  _c(
                    "el-radio-group",
                    {
                      model: {
                        value:
                          _vm.schoolConfigInSysResponse
                            .approvedAttendanceArrive,
                        callback: function ($$v) {
                          _vm.$set(
                            _vm.schoolConfigInSysResponse,
                            "approvedAttendanceArrive",
                            $$v
                          )
                        },
                        expression:
                          "schoolConfigInSysResponse.approvedAttendanceArrive",
                      },
                    },
                    [
                      _c("el-radio", { attrs: { label: true } }, [
                        _vm._v("Có"),
                      ]),
                      _c("el-radio", { attrs: { label: false } }, [
                        _vm._v("Không"),
                      ]),
                    ],
                    1
                  ),
                ],
                1
              ),
            ]),
            _c("tr", [
              _c("td", { staticClass: "table-index" }, [_vm._v("9")]),
              _c("td", [
                _vm._v("Giới hạn thời gian gửi điểm danh đến trước mấy giờ?"),
              ]),
              _c(
                "td",
                { staticClass: "table-action" },
                [
                  _c("el-time-picker", {
                    staticClass: "input-data",
                    attrs: {
                      size: "mini",
                      clearable: false,
                      type: "time",
                      "value-format": "HH:mm",
                      format: "HH:mm",
                      "picker-options": {
                        selectableRange: "00:00:00 - 23:59:59",
                      },
                      placeholder: "Chọn",
                    },
                    model: {
                      value: _vm.schoolConfigInSysResponse.timeAttendanceArrive,
                      callback: function ($$v) {
                        _vm.$set(
                          _vm.schoolConfigInSysResponse,
                          "timeAttendanceArrive",
                          $$v
                        )
                      },
                      expression:
                        "schoolConfigInSysResponse.timeAttendanceArrive",
                    },
                  }),
                ],
                1
              ),
            ]),
            _c("tr", [
              _c("td", { staticClass: "table-index" }, [_vm._v("10")]),
              _c("td", [_vm._v("Có gửi thông báo điểm danh về hay không?")]),
              _c(
                "td",
                { staticClass: "table-action" },
                [
                  _c(
                    "el-radio-group",
                    {
                      model: {
                        value:
                          _vm.schoolConfigInSysResponse.approvedAttendanceLeave,
                        callback: function ($$v) {
                          _vm.$set(
                            _vm.schoolConfigInSysResponse,
                            "approvedAttendanceLeave",
                            $$v
                          )
                        },
                        expression:
                          "schoolConfigInSysResponse.approvedAttendanceLeave",
                      },
                    },
                    [
                      _c("el-radio", { attrs: { label: true } }, [
                        _vm._v("Có"),
                      ]),
                      _c("el-radio", { attrs: { label: false } }, [
                        _vm._v("Không"),
                      ]),
                    ],
                    1
                  ),
                ],
                1
              ),
            ]),
            _c("tr", [
              _c("td", { staticClass: "table-index" }, [_vm._v("11")]),
              _c("td", [
                _vm._v("Giới hạn thời gian gửi điểm danh về trước mấy giờ?"),
              ]),
              _c(
                "td",
                { staticClass: "table-action" },
                [
                  _c("el-time-picker", {
                    staticClass: "input-data",
                    attrs: {
                      size: "mini",
                      clearable: false,
                      type: "time",
                      "value-format": "HH:mm",
                      format: "HH:mm",
                      "picker-options": {
                        selectableRange: "00:00:00 - 23:59:59",
                      },
                      placeholder: "Chọn",
                    },
                    model: {
                      value: _vm.schoolConfigInSysResponse.timeAttendanceLeave,
                      callback: function ($$v) {
                        _vm.$set(
                          _vm.schoolConfigInSysResponse,
                          "timeAttendanceLeave",
                          $$v
                        )
                      },
                      expression:
                        "schoolConfigInSysResponse.timeAttendanceLeave",
                    },
                  }),
                ],
                1
              ),
            ]),
            _c("tr", [
              _c("td", { staticClass: "table-index" }, [_vm._v("12")]),
              _c(
                "td",
                [
                  _vm._v(
                    "Cho phép giáo viên điểm danh lại với học sinh mấy ngày trước?\n            "
                  ),
                  _c(
                    "el-tooltip",
                    { attrs: { effect: "dark", placement: "top" } },
                    [
                      _c("div", {
                        attrs: { slot: "content" },
                        domProps: {
                          innerHTML: _vm._s(_vm.tooltips.againAttendance),
                        },
                        slot: "content",
                      }),
                      _c("i", {
                        staticClass: "el-icon-question ml-1",
                        staticStyle: { cursor: "pointer", color: "#3091f5" },
                      }),
                    ]
                  ),
                ],
                1
              ),
              _c(
                "td",
                { staticClass: "table-action" },
                [
                  _c("el-input", {
                    staticClass: "input-data",
                    attrs: { size: "mini", placeholder: "Nhập số ngày" },
                    model: {
                      value: _vm.schoolConfigInSysResponse.againAttendance,
                      callback: function ($$v) {
                        _vm.$set(
                          _vm.schoolConfigInSysResponse,
                          "againAttendance",
                          $$v
                        )
                      },
                      expression: "schoolConfigInSysResponse.againAttendance",
                    },
                  }),
                  _c("el-time-picker", {
                    staticClass: "input-data",
                    staticStyle: { "margin-top": "20px" },
                    attrs: {
                      size: "mini",
                      clearable: false,
                      type: "time",
                      "value-format": "HH:mm",
                      format: "HH:mm",
                      "picker-options": {
                        selectableRange: "00:00:00 - 23:59:59",
                      },
                      placeholder: "Chọn",
                    },
                    model: {
                      value: _vm.schoolConfigInSysResponse.timeAttendanceLimit,
                      callback: function ($$v) {
                        _vm.$set(
                          _vm.schoolConfigInSysResponse,
                          "timeAttendanceLimit",
                          $$v
                        )
                      },
                      expression:
                        "\n                schoolConfigInSysResponse.timeAttendanceLimit\n              ",
                    },
                  }),
                ],
                1
              ),
            ]),
            _c("tr", [
              _c("td", { staticClass: "table-index" }, [_vm._v("13")]),
              _c("td", [
                _vm._v(
                  "\n            Gửi đơn xin nghỉ phải trước ngày đầu tiên muốn nghỉ số ngày là?\n          "
                ),
              ]),
              _c(
                "td",
                { staticClass: "table-action" },
                [
                  _c("el-input", {
                    staticClass: "input-data",
                    attrs: { size: "mini", placeholder: "Nhập số ngày" },
                    model: {
                      value: _vm.schoolConfigInSysResponse.dateAbsent,
                      callback: function ($$v) {
                        _vm.$set(
                          _vm.schoolConfigInSysResponse,
                          "dateAbsent",
                          $$v
                        )
                      },
                      expression: "schoolConfigInSysResponse.dateAbsent",
                    },
                  }),
                ],
                1
              ),
            ]),
            _c("tr", [
              _c("td", { staticClass: "table-index" }, [_vm._v("14")]),
              _c("td", [_vm._v("Thời gian xin nghỉ phải trước mấy giờ?")]),
              _c(
                "td",
                { staticClass: "table-action" },
                [
                  _c("el-time-picker", {
                    staticClass: "input-data",
                    attrs: {
                      size: "mini",
                      clearable: false,
                      type: "time",
                      "value-format": "HH:mm",
                      format: "HH:mm",
                      "picker-options": {
                        selectableRange: "00:00:00 - 23:59:59",
                      },
                      placeholder: "Chọn",
                    },
                    model: {
                      value: _vm.schoolConfigInSysResponse.timeAbsent,
                      callback: function ($$v) {
                        _vm.$set(
                          _vm.schoolConfigInSysResponse,
                          "timeAbsent",
                          $$v
                        )
                      },
                      expression: "schoolConfigInSysResponse.timeAbsent",
                    },
                  }),
                ],
                1
              ),
            ]),
            _c("tr", [
              _c("td", { staticClass: "table-index" }, [_vm._v("15")]),
              _c("td", [_vm._v("Mặc định có học sáng thứ 7 hàng tuần không?")]),
              _c(
                "td",
                { staticClass: "table-action" },
                [
                  _c(
                    "el-radio-group",
                    {
                      model: {
                        value: _vm.schoolConfigInSysResponse.morningSaturday,
                        callback: function ($$v) {
                          _vm.$set(
                            _vm.schoolConfigInSysResponse,
                            "morningSaturday",
                            $$v
                          )
                        },
                        expression: "schoolConfigInSysResponse.morningSaturday",
                      },
                    },
                    [
                      _c("el-radio", { attrs: { label: true } }, [
                        _vm._v("Có"),
                      ]),
                      _c("el-radio", { attrs: { label: false } }, [
                        _vm._v("Không"),
                      ]),
                    ],
                    1
                  ),
                ],
                1
              ),
            ]),
            _c("tr", [
              _c("td", { staticClass: "table-index" }, [_vm._v("16")]),
              _c("td", [
                _vm._v("Mặc định có học chiều thứ 7 hàng tuần không?"),
              ]),
              _c(
                "td",
                { staticClass: "table-action" },
                [
                  _c(
                    "el-radio-group",
                    {
                      model: {
                        value: _vm.schoolConfigInSysResponse.afternoonSaturday,
                        callback: function ($$v) {
                          _vm.$set(
                            _vm.schoolConfigInSysResponse,
                            "afternoonSaturday",
                            $$v
                          )
                        },
                        expression:
                          "schoolConfigInSysResponse.afternoonSaturday",
                      },
                    },
                    [
                      _c("el-radio", { attrs: { label: true } }, [
                        _vm._v("Có"),
                      ]),
                      _c("el-radio", { attrs: { label: false } }, [
                        _vm._v("Không"),
                      ]),
                    ],
                    1
                  ),
                ],
                1
              ),
            ]),
            _c("tr", [
              _c("td", { staticClass: "table-index" }, [_vm._v("17")]),
              _c("td", [_vm._v("Mặc định có học tối thứ 7 hàng tuần không?")]),
              _c(
                "td",
                { staticClass: "table-action" },
                [
                  _c(
                    "el-radio-group",
                    {
                      model: {
                        value: _vm.schoolConfigInSysResponse.eveningSaturday,
                        callback: function ($$v) {
                          _vm.$set(
                            _vm.schoolConfigInSysResponse,
                            "eveningSaturday",
                            $$v
                          )
                        },
                        expression: "schoolConfigInSysResponse.eveningSaturday",
                      },
                    },
                    [
                      _c("el-radio", { attrs: { label: true } }, [
                        _vm._v("Có"),
                      ]),
                      _c("el-radio", { attrs: { label: false } }, [
                        _vm._v("Không"),
                      ]),
                    ],
                    1
                  ),
                ],
                1
              ),
            ]),
            _c("tr", [
              _c("td", { staticClass: "table-index" }, [_vm._v("18")]),
              _c("td", [_vm._v("Mặc định có học chủ nhật hàng tuần không?")]),
              _c(
                "td",
                { staticClass: "table-action" },
                [
                  _c(
                    "el-radio-group",
                    {
                      model: {
                        value: _vm.schoolConfigInSysResponse.sunday,
                        callback: function ($$v) {
                          _vm.$set(_vm.schoolConfigInSysResponse, "sunday", $$v)
                        },
                        expression: "schoolConfigInSysResponse.sunday",
                      },
                    },
                    [
                      _c("el-radio", { attrs: { label: true } }, [
                        _vm._v("Có"),
                      ]),
                      _c("el-radio", { attrs: { label: false } }, [
                        _vm._v("Không"),
                      ]),
                    ],
                    1
                  ),
                ],
                1
              ),
            ]),
            _c("tr", [
              _c("td", { staticClass: "table-index" }, [_vm._v("19")]),
              _c("td", [_vm._v("Hiển thị điểm danh đi học buổi sáng không?")]),
              _c(
                "td",
                { staticClass: "table-action" },
                [
                  _c(
                    "el-radio-group",
                    {
                      model: {
                        value:
                          _vm.schoolConfigInSysResponse.morningAttendanceArrive,
                        callback: function ($$v) {
                          _vm.$set(
                            _vm.schoolConfigInSysResponse,
                            "morningAttendanceArrive",
                            $$v
                          )
                        },
                        expression:
                          "schoolConfigInSysResponse.morningAttendanceArrive",
                      },
                    },
                    [
                      _c("el-radio", { attrs: { label: true } }, [
                        _vm._v("Có"),
                      ]),
                      _c("el-radio", { attrs: { label: false } }, [
                        _vm._v("Không"),
                      ]),
                    ],
                    1
                  ),
                ],
                1
              ),
            ]),
            _c("tr", [
              _c("td", { staticClass: "table-index" }, [_vm._v("20")]),
              _c("td", [_vm._v("Hiển thị điểm danh đi học buổi chiều không?")]),
              _c(
                "td",
                { staticClass: "table-action" },
                [
                  _c(
                    "el-radio-group",
                    {
                      model: {
                        value:
                          _vm.schoolConfigInSysResponse
                            .afternoonAttendanceArrive,
                        callback: function ($$v) {
                          _vm.$set(
                            _vm.schoolConfigInSysResponse,
                            "afternoonAttendanceArrive",
                            $$v
                          )
                        },
                        expression:
                          "schoolConfigInSysResponse.afternoonAttendanceArrive",
                      },
                    },
                    [
                      _c("el-radio", { attrs: { label: true } }, [
                        _vm._v("Có"),
                      ]),
                      _c("el-radio", { attrs: { label: false } }, [
                        _vm._v("Không"),
                      ]),
                    ],
                    1
                  ),
                ],
                1
              ),
            ]),
            _c("tr", [
              _c("td", { staticClass: "table-index" }, [_vm._v("21")]),
              _c("td", [_vm._v("Hiển thị điểm danh đi học buổi tối không?")]),
              _c(
                "td",
                { staticClass: "table-action" },
                [
                  _c(
                    "el-radio-group",
                    {
                      model: {
                        value:
                          _vm.schoolConfigInSysResponse.eveningAttendanceArrive,
                        callback: function ($$v) {
                          _vm.$set(
                            _vm.schoolConfigInSysResponse,
                            "eveningAttendanceArrive",
                            $$v
                          )
                        },
                        expression:
                          "schoolConfigInSysResponse.eveningAttendanceArrive",
                      },
                    },
                    [
                      _c("el-radio", { attrs: { label: true } }, [
                        _vm._v("Có"),
                      ]),
                      _c("el-radio", { attrs: { label: false } }, [
                        _vm._v("Không"),
                      ]),
                    ],
                    1
                  ),
                ],
                1
              ),
            ]),
            _c("tr", [
              _c("td", { staticClass: "table-index" }, [_vm._v("22")]),
              _c("td", [_vm._v("Hiển thị điểm danh ăn bữa sáng không?")]),
              _c(
                "td",
                { staticClass: "table-action" },
                [
                  _c(
                    "el-radio-group",
                    {
                      model: {
                        value: _vm.schoolConfigInSysResponse.morningEat,
                        callback: function ($$v) {
                          _vm.$set(
                            _vm.schoolConfigInSysResponse,
                            "morningEat",
                            $$v
                          )
                        },
                        expression: "schoolConfigInSysResponse.morningEat",
                      },
                    },
                    [
                      _c("el-radio", { attrs: { label: true } }, [
                        _vm._v("Có"),
                      ]),
                      _c("el-radio", { attrs: { label: false } }, [
                        _vm._v("Không"),
                      ]),
                    ],
                    1
                  ),
                ],
                1
              ),
            ]),
            _c("tr", [
              _c("td", { staticClass: "table-index" }, [_vm._v("23")]),
              _c("td", [_vm._v("Hiển thị điểm danh ăn bữa phụ sáng không?")]),
              _c(
                "td",
                { staticClass: "table-action" },
                [
                  _c(
                    "el-radio-group",
                    {
                      model: {
                        value: _vm.schoolConfigInSysResponse.secondMorningEat,
                        callback: function ($$v) {
                          _vm.$set(
                            _vm.schoolConfigInSysResponse,
                            "secondMorningEat",
                            $$v
                          )
                        },
                        expression:
                          "schoolConfigInSysResponse.secondMorningEat",
                      },
                    },
                    [
                      _c("el-radio", { attrs: { label: true } }, [
                        _vm._v("Có"),
                      ]),
                      _c("el-radio", { attrs: { label: false } }, [
                        _vm._v("Không"),
                      ]),
                    ],
                    1
                  ),
                ],
                1
              ),
            ]),
            _c("tr", [
              _c("td", { staticClass: "table-index" }, [_vm._v("24")]),
              _c("td", [_vm._v("Hiển thị điểm danh ăn bữa trưa không?")]),
              _c(
                "td",
                { staticClass: "table-action" },
                [
                  _c(
                    "el-radio-group",
                    {
                      model: {
                        value: _vm.schoolConfigInSysResponse.lunchEat,
                        callback: function ($$v) {
                          _vm.$set(
                            _vm.schoolConfigInSysResponse,
                            "lunchEat",
                            $$v
                          )
                        },
                        expression: "schoolConfigInSysResponse.lunchEat",
                      },
                    },
                    [
                      _c("el-radio", { attrs: { label: true } }, [
                        _vm._v("Có"),
                      ]),
                      _c("el-radio", { attrs: { label: false } }, [
                        _vm._v("Không"),
                      ]),
                    ],
                    1
                  ),
                ],
                1
              ),
            ]),
            _c("tr", [
              _c("td", { staticClass: "table-index" }, [_vm._v("25")]),
              _c("td", [_vm._v("Hiển thị điểm danh ăn bữa chiều không?")]),
              _c(
                "td",
                { staticClass: "table-action" },
                [
                  _c(
                    "el-radio-group",
                    {
                      model: {
                        value: _vm.schoolConfigInSysResponse.afternoonEat,
                        callback: function ($$v) {
                          _vm.$set(
                            _vm.schoolConfigInSysResponse,
                            "afternoonEat",
                            $$v
                          )
                        },
                        expression: "schoolConfigInSysResponse.afternoonEat",
                      },
                    },
                    [
                      _c("el-radio", { attrs: { label: true } }, [
                        _vm._v("Có"),
                      ]),
                      _c("el-radio", { attrs: { label: false } }, [
                        _vm._v("Không"),
                      ]),
                    ],
                    1
                  ),
                ],
                1
              ),
            ]),
            _c("tr", [
              _c("td", { staticClass: "table-index" }, [_vm._v("26")]),
              _c("td", [_vm._v("Hiển thị điểm danh ăn bữa phụ chiều không?")]),
              _c(
                "td",
                { staticClass: "table-action" },
                [
                  _c(
                    "el-radio-group",
                    {
                      model: {
                        value: _vm.schoolConfigInSysResponse.secondAfternoonEat,
                        callback: function ($$v) {
                          _vm.$set(
                            _vm.schoolConfigInSysResponse,
                            "secondAfternoonEat",
                            $$v
                          )
                        },
                        expression:
                          "schoolConfigInSysResponse.secondAfternoonEat",
                      },
                    },
                    [
                      _c("el-radio", { attrs: { label: true } }, [
                        _vm._v("Có"),
                      ]),
                      _c("el-radio", { attrs: { label: false } }, [
                        _vm._v("Không"),
                      ]),
                    ],
                    1
                  ),
                ],
                1
              ),
            ]),
            _c("tr", [
              _c("td", { staticClass: "table-index" }, [_vm._v("27")]),
              _c("td", [_vm._v("Hiển thị điểm danh ăn bữa tối không?")]),
              _c(
                "td",
                { staticClass: "table-action" },
                [
                  _c(
                    "el-radio-group",
                    {
                      model: {
                        value: _vm.schoolConfigInSysResponse.eveningEat,
                        callback: function ($$v) {
                          _vm.$set(
                            _vm.schoolConfigInSysResponse,
                            "eveningEat",
                            $$v
                          )
                        },
                        expression: "schoolConfigInSysResponse.eveningEat",
                      },
                    },
                    [
                      _c("el-radio", { attrs: { label: true } }, [
                        _vm._v("Có"),
                      ]),
                      _c("el-radio", { attrs: { label: false } }, [
                        _vm._v("Không"),
                      ]),
                    ],
                    1
                  ),
                ],
                1
              ),
            ]),
            _c("tr", [
              _c("td", { staticClass: "table-index" }, [_vm._v("28")]),
              _c("td", [
                _vm._v("Có cần duyệt các thông báo gửi đi hay không?"),
              ]),
              _c(
                "td",
                { staticClass: "table-action" },
                [
                  _c(
                    "el-radio-group",
                    {
                      model: {
                        value: _vm.schoolConfigInSysResponse.appSendApproved,
                        callback: function ($$v) {
                          _vm.$set(
                            _vm.schoolConfigInSysResponse,
                            "appSendApproved",
                            $$v
                          )
                        },
                        expression: "schoolConfigInSysResponse.appSendApproved",
                      },
                    },
                    [
                      _c("el-radio", { attrs: { label: false } }, [
                        _vm._v("Có"),
                      ]),
                      _c("el-radio", { attrs: { label: true } }, [
                        _vm._v("Không"),
                      ]),
                    ],
                    1
                  ),
                ],
                1
              ),
            ]),
            _c("tr", [
              _c("td", { staticClass: "table-index" }, [_vm._v("29")]),
              _c("td", [
                _vm._v("Có cần duyệt nội dung thời khóa biểu hay không?"),
              ]),
              _c(
                "td",
                { staticClass: "table-action" },
                [
                  _c(
                    "el-radio-group",
                    {
                      model: {
                        value: _vm.schoolConfigInSysResponse.approvedSchedule,
                        callback: function ($$v) {
                          _vm.$set(
                            _vm.schoolConfigInSysResponse,
                            "approvedSchedule",
                            $$v
                          )
                        },
                        expression:
                          "schoolConfigInSysResponse.approvedSchedule",
                      },
                    },
                    [
                      _c("el-radio", { attrs: { label: true } }, [
                        _vm._v("Có"),
                      ]),
                      _c("el-radio", { attrs: { label: false } }, [
                        _vm._v("Không"),
                      ]),
                    ],
                    1
                  ),
                ],
                1
              ),
            ]),
            _c("tr", [
              _c("td", { staticClass: "table-index" }, [_vm._v("30")]),
              _c("td", [_vm._v("Có cần duyệt nội dung thực đơn hay không?")]),
              _c(
                "td",
                { staticClass: "table-action" },
                [
                  _c(
                    "el-radio-group",
                    {
                      model: {
                        value: _vm.schoolConfigInSysResponse.approvedMenu,
                        callback: function ($$v) {
                          _vm.$set(
                            _vm.schoolConfigInSysResponse,
                            "approvedMenu",
                            $$v
                          )
                        },
                        expression: "schoolConfigInSysResponse.approvedMenu",
                      },
                    },
                    [
                      _c("el-radio", { attrs: { label: true } }, [
                        _vm._v("Có"),
                      ]),
                      _c("el-radio", { attrs: { label: false } }, [
                        _vm._v("Không"),
                      ]),
                    ],
                    1
                  ),
                ],
                1
              ),
            ]),
            _c("tr", [
              _c("td", { staticClass: "table-index" }, [_vm._v("31")]),
              _c("td", [
                _vm._v(
                  "\n            Cho phép hiển thị số điện thoại của Phụ huynh với App Giáo viên?\n          "
                ),
              ]),
              _c(
                "td",
                { staticClass: "table-action" },
                [
                  _c(
                    "el-radio-group",
                    {
                      model: {
                        value: _vm.schoolConfigInSysResponse.parentPhone,
                        callback: function ($$v) {
                          _vm.$set(
                            _vm.schoolConfigInSysResponse,
                            "parentPhone",
                            $$v
                          )
                        },
                        expression: "schoolConfigInSysResponse.parentPhone",
                      },
                    },
                    [
                      _c("el-radio", { attrs: { label: true } }, [
                        _vm._v("Có"),
                      ]),
                      _c("el-radio", { attrs: { label: false } }, [
                        _vm._v("Không"),
                      ]),
                    ],
                    1
                  ),
                ],
                1
              ),
            ]),
            _c("tr", [
              _c("td", { staticClass: "table-index" }, [_vm._v("32")]),
              _c("td", [
                _vm._v(
                  "\n            Cho phép Giáo viên xem thông tin chi tiết của Phụ huynh hay\n            không?\n          "
                ),
              ]),
              _c(
                "td",
                { staticClass: "table-action" },
                [
                  _c(
                    "el-radio-group",
                    {
                      model: {
                        value: _vm.schoolConfigInSysResponse.parentInfo,
                        callback: function ($$v) {
                          _vm.$set(
                            _vm.schoolConfigInSysResponse,
                            "parentInfo",
                            $$v
                          )
                        },
                        expression: "schoolConfigInSysResponse.parentInfo",
                      },
                    },
                    [
                      _c("el-radio", { attrs: { label: true } }, [
                        _vm._v("Có"),
                      ]),
                      _c("el-radio", { attrs: { label: false } }, [
                        _vm._v("Không"),
                      ]),
                    ],
                    1
                  ),
                ],
                1
              ),
            ]),
            _c("tr", [
              _c("td", { staticClass: "table-index" }, [_vm._v("33")]),
              _c("td", [
                _vm._v(
                  "\n            Cho phép hiển thị số điện thoại của Giáo viên với App Phụ huynh?\n          "
                ),
              ]),
              _c(
                "td",
                { staticClass: "table-action" },
                [
                  _c(
                    "el-radio-group",
                    {
                      model: {
                        value: _vm.schoolConfigInSysResponse.employeePhone,
                        callback: function ($$v) {
                          _vm.$set(
                            _vm.schoolConfigInSysResponse,
                            "employeePhone",
                            $$v
                          )
                        },
                        expression: "schoolConfigInSysResponse.employeePhone",
                      },
                    },
                    [
                      _c("el-radio", { attrs: { label: true } }, [
                        _vm._v("Có"),
                      ]),
                      _c("el-radio", { attrs: { label: false } }, [
                        _vm._v("Không"),
                      ]),
                    ],
                    1
                  ),
                ],
                1
              ),
            ]),
            _c("tr", [
              _c("td", { staticClass: "table-index" }, [_vm._v("34")]),
              _c("td", [
                _vm._v(
                  "\n            Cho phép Phụ huynh xem thông tin chi tiết của Giáo viên không?\n          "
                ),
              ]),
              _c(
                "td",
                { staticClass: "table-action" },
                [
                  _c(
                    "el-radio-group",
                    {
                      model: {
                        value: _vm.schoolConfigInSysResponse.employeeInfo,
                        callback: function ($$v) {
                          _vm.$set(
                            _vm.schoolConfigInSysResponse,
                            "employeeInfo",
                            $$v
                          )
                        },
                        expression: "schoolConfigInSysResponse.employeeInfo",
                      },
                    },
                    [
                      _c("el-radio", { attrs: { label: true } }, [
                        _vm._v("Có"),
                      ]),
                      _c("el-radio", { attrs: { label: false } }, [
                        _vm._v("Không"),
                      ]),
                    ],
                    1
                  ),
                ],
                1
              ),
            ]),
            _c("tr", [
              _c("td", { staticClass: "table-index" }, [_vm._v("35")]),
              _c("td", [
                _vm._v(
                  "\n            Cho phép Phụ huynh xem lại lịch sử học của con khi đã chuyển\n            trường hay không?\n          "
                ),
              ]),
              _c(
                "td",
                { staticClass: "table-action" },
                [
                  _c(
                    "el-radio-group",
                    {
                      model: {
                        value: _vm.schoolConfigInSysResponse.historyViewParent,
                        callback: function ($$v) {
                          _vm.$set(
                            _vm.schoolConfigInSysResponse,
                            "historyViewParent",
                            $$v
                          )
                        },
                        expression:
                          "schoolConfigInSysResponse.historyViewParent",
                      },
                    },
                    [
                      _c("el-radio", { attrs: { label: true } }, [
                        _vm._v("Có"),
                      ]),
                      _c("el-radio", { attrs: { label: false } }, [
                        _vm._v("Không"),
                      ]),
                    ],
                    1
                  ),
                ],
                1
              ),
            ]),
            _c("tr", [
              _c("td", { staticClass: "table-index" }, [_vm._v("36")]),
              _c("td", [
                _vm._v(
                  "\n            Cho phép Nhân viên xem lại lịch sử làm việc khi đã nghỉ làm ở\n            trường hày không?\n          "
                ),
              ]),
              _c(
                "td",
                { staticClass: "table-action" },
                [
                  _c(
                    "el-radio-group",
                    {
                      model: {
                        value: _vm.schoolConfigInSysResponse.historyViewTeacher,
                        callback: function ($$v) {
                          _vm.$set(
                            _vm.schoolConfigInSysResponse,
                            "historyViewTeacher",
                            $$v
                          )
                        },
                        expression:
                          "schoolConfigInSysResponse.historyViewTeacher",
                      },
                    },
                    [
                      _c("el-radio", { attrs: { label: true } }, [
                        _vm._v("Có"),
                      ]),
                      _c("el-radio", { attrs: { label: false } }, [
                        _vm._v("Không"),
                      ]),
                    ],
                    1
                  ),
                ],
                1
              ),
            ]),
            _c("tr", [
              _c("td", { staticClass: "table-index" }, [_vm._v("37")]),
              _c("td", [
                _vm._v(
                  "\n            Giáo viên có được xem chi tiết các khoản thu của học sinh lớp\n            mình hay không?\n          "
                ),
              ]),
              _c(
                "td",
                { staticClass: "table-action" },
                [
                  _c(
                    "el-radio-group",
                    {
                      model: {
                        value: _vm.schoolConfigInSysResponse.feesInfo,
                        callback: function ($$v) {
                          _vm.$set(
                            _vm.schoolConfigInSysResponse,
                            "feesInfo",
                            $$v
                          )
                        },
                        expression: "schoolConfigInSysResponse.feesInfo",
                      },
                    },
                    [
                      _c("el-radio", { attrs: { label: true } }, [
                        _vm._v("Có"),
                      ]),
                      _c("el-radio", { attrs: { label: false } }, [
                        _vm._v("Không"),
                      ]),
                    ],
                    1
                  ),
                ],
                1
              ),
            ]),
            _c("tr", [
              _c("td", { staticClass: "table-index" }, [_vm._v("38")]),
              _c("td", [
                _vm._v(
                  "\n            Giáo viên có được xem số tiền học phí của học sinh hay không?\n          "
                ),
              ]),
              _c(
                "td",
                { staticClass: "table-action" },
                [
                  _c(
                    "el-radio-group",
                    {
                      model: {
                        value: _vm.schoolConfigInSysResponse.feesNumber,
                        callback: function ($$v) {
                          _vm.$set(
                            _vm.schoolConfigInSysResponse,
                            "feesNumber",
                            $$v
                          )
                        },
                        expression: "schoolConfigInSysResponse.feesNumber",
                      },
                    },
                    [
                      _c("el-radio", { attrs: { label: true } }, [
                        _vm._v("Có"),
                      ]),
                      _c("el-radio", { attrs: { label: false } }, [
                        _vm._v("Không"),
                      ]),
                    ],
                    1
                  ),
                ],
                1
              ),
            ]),
            _c("tr", [
              _c("td", { staticClass: "table-index" }, [_vm._v("39")]),
              _c("td", [
                _vm._v(
                  "Thiết lập giờ đến quy định của Nhà trường với học sinh?"
                ),
              ]),
              _c(
                "td",
                { staticClass: "table-action" },
                [
                  _c("el-time-picker", {
                    staticClass: "input-data",
                    attrs: {
                      size: "mini",
                      clearable: false,
                      type: "time",
                      "value-format": "HH:mm",
                      format: "HH:mm",
                      "picker-options": {
                        selectableRange: "00:00:00 - 23:59:59",
                      },
                      placeholder: "Chọn",
                    },
                    model: {
                      value: _vm.schoolConfigInSysResponse.timeArriveKid,
                      callback: function ($$v) {
                        _vm.$set(
                          _vm.schoolConfigInSysResponse,
                          "timeArriveKid",
                          $$v
                        )
                      },
                      expression: "schoolConfigInSysResponse.timeArriveKid",
                    },
                  }),
                ],
                1
              ),
            ]),
            _c("tr", [
              _c("td", { staticClass: "table-index" }, [_vm._v("40")]),
              _c("td", [
                _vm._v(
                  "Thiết lập giờ về quy định của Nhà trường với học sinh?"
                ),
              ]),
              _c(
                "td",
                { staticClass: "table-action" },
                [
                  _c("el-time-picker", {
                    staticClass: "input-data",
                    attrs: {
                      size: "mini",
                      clearable: false,
                      type: "time",
                      "value-format": "HH:mm",
                      format: "HH:mm",
                      "picker-options": {
                        selectableRange: "00:00:00 - 23:59:59",
                      },
                      placeholder: "Chọn",
                    },
                    model: {
                      value: _vm.schoolConfigInSysResponse.timePickupKid,
                      callback: function ($$v) {
                        _vm.$set(
                          _vm.schoolConfigInSysResponse,
                          "timePickupKid",
                          $$v
                        )
                      },
                      expression: "schoolConfigInSysResponse.timePickupKid",
                    },
                  }),
                ],
                1
              ),
            ]),
            _c("tr", [
              _c("td", { staticClass: "table-index" }, [_vm._v("41")]),
              _c("td", [_vm._v("Hiển thị thêm mẫu nhận xét của hệ thống?")]),
              _c(
                "td",
                { staticClass: "table-action" },
                [
                  _c(
                    "el-radio-group",
                    {
                      model: {
                        value: _vm.schoolConfigInSysResponse.showEvaluateSys,
                        callback: function ($$v) {
                          _vm.$set(
                            _vm.schoolConfigInSysResponse,
                            "showEvaluateSys",
                            $$v
                          )
                        },
                        expression: "schoolConfigInSysResponse.showEvaluateSys",
                      },
                    },
                    [
                      _c("el-radio", { attrs: { label: true } }, [
                        _vm._v("Có"),
                      ]),
                      _c("el-radio", { attrs: { label: false } }, [
                        _vm._v("Không"),
                      ]),
                    ],
                    1
                  ),
                ],
                1
              ),
            ]),
            _c("tr", [
              _c("td", { staticClass: "table-index" }, [_vm._v("42")]),
              _c("td", [
                _vm._v("Hiển thị thêm mẫu báo đến, báo về của hệ thống?"),
              ]),
              _c(
                "td",
                { staticClass: "table-action" },
                [
                  _c(
                    "el-radio-group",
                    {
                      model: {
                        value:
                          _vm.schoolConfigInSysResponse.showAttentendanceSys,
                        callback: function ($$v) {
                          _vm.$set(
                            _vm.schoolConfigInSysResponse,
                            "showAttentendanceSys",
                            $$v
                          )
                        },
                        expression:
                          "schoolConfigInSysResponse.showAttentendanceSys",
                      },
                    },
                    [
                      _c("el-radio", { attrs: { label: true } }, [
                        _vm._v("Có"),
                      ]),
                      _c("el-radio", { attrs: { label: false } }, [
                        _vm._v("Không"),
                      ]),
                    ],
                    1
                  ),
                ],
                1
              ),
            ]),
            _c("tr", [
              _c("td", { staticClass: "table-index" }, [_vm._v("43")]),
              _c("td", [_vm._v("Hiển thị thêm mẫu lời chúc của hệ thống?")]),
              _c(
                "td",
                { staticClass: "table-action" },
                [
                  _c(
                    "el-radio-group",
                    {
                      model: {
                        value: _vm.schoolConfigInSysResponse.showWishSys,
                        callback: function ($$v) {
                          _vm.$set(
                            _vm.schoolConfigInSysResponse,
                            "showWishSys",
                            $$v
                          )
                        },
                        expression: "schoolConfigInSysResponse.showWishSys",
                      },
                    },
                    [
                      _c("el-radio", { attrs: { label: true } }, [
                        _vm._v("Có"),
                      ]),
                      _c("el-radio", { attrs: { label: false } }, [
                        _vm._v("Không"),
                      ]),
                    ],
                    1
                  ),
                ],
                1
              ),
            ]),
            _c("tr", [
              _c("td", { staticClass: "table-index" }, [_vm._v("44")]),
              _c("td", [
                _vm._v(
                  "Thiết lập giờ đi làm buổi sáng của Nhân viên Nhà trường?"
                ),
              ]),
              _c(
                "td",
                { staticClass: "table-action" },
                [
                  _c("el-time-picker", {
                    staticClass: "input-data",
                    attrs: {
                      size: "mini",
                      clearable: false,
                      type: "time",
                      "value-format": "HH:mm",
                      format: "HH:mm",
                      "picker-options": {
                        selectableRange: "00:00:00 - 23:59:59",
                      },
                      placeholder: "Chọn",
                    },
                    model: {
                      value: _vm.schoolConfigInSysResponse.timeArriveEmployee,
                      callback: function ($$v) {
                        _vm.$set(
                          _vm.schoolConfigInSysResponse,
                          "timeArriveEmployee",
                          $$v
                        )
                      },
                      expression:
                        "schoolConfigInSysResponse.timeArriveEmployee",
                    },
                  }),
                ],
                1
              ),
            ]),
            _c("tr", [
              _c("td", { staticClass: "table-index" }, [_vm._v("45")]),
              _c("td", [_vm._v("Thiết lập giờ về của Nhân viên Nhà trường?")]),
              _c(
                "td",
                { staticClass: "table-action" },
                [
                  _c("el-time-picker", {
                    staticClass: "input-data",
                    attrs: {
                      size: "mini",
                      clearable: false,
                      type: "time",
                      "value-format": "HH:mm",
                      format: "HH:mm",
                      "picker-options": {
                        selectableRange: "00:00:00 - 23:59:59",
                      },
                      placeholder: "Chọn",
                    },
                    model: {
                      value: _vm.schoolConfigInSysResponse.timeLeaveEmployee,
                      callback: function ($$v) {
                        _vm.$set(
                          _vm.schoolConfigInSysResponse,
                          "timeLeaveEmployee",
                          $$v
                        )
                      },
                      expression: "schoolConfigInSysResponse.timeLeaveEmployee",
                    },
                  }),
                ],
                1
              ),
            ]),
            _c("tr", [
              _c("td", { staticClass: "table-index" }, [_vm._v("46")]),
              _c("td", [_vm._v("Có tự động duyệt các phiếu thu không?")]),
              _c(
                "td",
                { staticClass: "table-action" },
                [
                  _c(
                    "el-radio-group",
                    {
                      model: {
                        value: _vm.schoolConfigInSysResponse.receiptNote,
                        callback: function ($$v) {
                          _vm.$set(
                            _vm.schoolConfigInSysResponse,
                            "receiptNote",
                            $$v
                          )
                        },
                        expression: "schoolConfigInSysResponse.receiptNote",
                      },
                    },
                    [
                      _c("el-radio", { attrs: { label: true } }, [
                        _vm._v("Có"),
                      ]),
                      _c("el-radio", { attrs: { label: false } }, [
                        _vm._v("Không"),
                      ]),
                    ],
                    1
                  ),
                ],
                1
              ),
            ]),
            _c("tr", [
              _c("td", { staticClass: "table-index" }, [_vm._v("47")]),
              _c("td", [_vm._v("Có tự động duyệt các phiếu chi không?")]),
              _c(
                "td",
                { staticClass: "table-action" },
                [
                  _c(
                    "el-radio-group",
                    {
                      model: {
                        value: _vm.schoolConfigInSysResponse.paymentNote,
                        callback: function ($$v) {
                          _vm.$set(
                            _vm.schoolConfigInSysResponse,
                            "paymentNote",
                            $$v
                          )
                        },
                        expression: "schoolConfigInSysResponse.paymentNote",
                      },
                    },
                    [
                      _c("el-radio", { attrs: { label: true } }, [
                        _vm._v("Có"),
                      ]),
                      _c("el-radio", { attrs: { label: false } }, [
                        _vm._v("Không"),
                      ]),
                    ],
                    1
                  ),
                ],
                1
              ),
            ]),
            _c("tr", [
              _c("td", { staticClass: "table-index" }, [_vm._v("48")]),
              _c("td", [
                _vm._v(
                  "\n            Có sinh tự động hóa đơn công lương của Nhân viên cho tháng tiếp\n            theo không (sinh tự động vào ngày đầu tháng)?\n          "
                ),
              ]),
              _c(
                "td",
                { staticClass: "table-action" },
                [
                  _c(
                    "el-radio-group",
                    {
                      model: {
                        value:
                          _vm.schoolConfigInSysResponse.autoBillSalaryEmployee,
                        callback: function ($$v) {
                          _vm.$set(
                            _vm.schoolConfigInSysResponse,
                            "autoBillSalaryEmployee",
                            $$v
                          )
                        },
                        expression:
                          "schoolConfigInSysResponse.autoBillSalaryEmployee",
                      },
                    },
                    [
                      _c("el-radio", { attrs: { label: true } }, [
                        _vm._v("Có"),
                      ]),
                      _c("el-radio", { attrs: { label: false } }, [
                        _vm._v("Không"),
                      ]),
                    ],
                    1
                  ),
                ],
                1
              ),
            ]),
            _c("tr", [
              _c("td", { staticClass: "table-index" }, [_vm._v("49")]),
              _c("td", [
                _vm._v(
                  "\n            Có sinh tự động các khoản công lương cho Nhân viên theo các\n            khoản mặc định?\n          "
                ),
              ]),
              _c(
                "td",
                { staticClass: "table-action" },
                [
                  _c(
                    "el-radio-group",
                    {
                      model: {
                        value:
                          _vm.schoolConfigInSysResponse.autoSignSalaryEmployee,
                        callback: function ($$v) {
                          _vm.$set(
                            _vm.schoolConfigInSysResponse,
                            "autoSignSalaryEmployee",
                            $$v
                          )
                        },
                        expression:
                          "schoolConfigInSysResponse.autoSignSalaryEmployee",
                      },
                    },
                    [
                      _c("el-radio", { attrs: { label: true } }, [
                        _vm._v("Có"),
                      ]),
                      _c("el-radio", { attrs: { label: false } }, [
                        _vm._v("Không"),
                      ]),
                    ],
                    1
                  ),
                ],
                1
              ),
            ]),
            _c("tr", [
              _c("td", { staticClass: "table-index" }, [_vm._v("50")]),
              _c("td", [
                _vm._v(
                  "\n            Thiết lập ngày của tháng sẽ sinh tự động các khoản công lương\n            cho Nhân sự?\n          "
                ),
              ]),
              _c(
                "td",
                { staticClass: "table-action" },
                [
                  _c("el-input-number", {
                    attrs: {
                      disabled:
                        !_vm.schoolConfigInSysResponse.autoSignSalaryEmployee,
                      size: "mini",
                      min: 1,
                      max: 31,
                    },
                    model: {
                      value:
                        _vm.schoolConfigInSysResponse.autoNextmonthSalaryDate,
                      callback: function ($$v) {
                        _vm.$set(
                          _vm.schoolConfigInSysResponse,
                          "autoNextmonthSalaryDate",
                          $$v
                        )
                      },
                      expression:
                        "schoolConfigInSysResponse.autoNextmonthSalaryDate",
                    },
                  }),
                ],
                1
              ),
            ]),
            _c("tr", [
              _c("td", { staticClass: "table-index" }, [_vm._v("51")]),
              _c("td", [
                _vm._v("Có tự động duyệt các khoản lương hàng tháng không?"),
              ]),
              _c(
                "td",
                { staticClass: "table-action" },
                [
                  _c(
                    "el-radio-group",
                    {
                      model: {
                        value: _vm.schoolConfigInSysResponse.autoApprovedSalary,
                        callback: function ($$v) {
                          _vm.$set(
                            _vm.schoolConfigInSysResponse,
                            "autoApprovedSalary",
                            $$v
                          )
                        },
                        expression:
                          "schoolConfigInSysResponse.autoApprovedSalary",
                      },
                    },
                    [
                      _c("el-radio", { attrs: { label: true } }, [
                        _vm._v("Có"),
                      ]),
                      _c("el-radio", { attrs: { label: false } }, [
                        _vm._v("Không"),
                      ]),
                    ],
                    1
                  ),
                ],
                1
              ),
            ]),
            _c("tr", [
              _c("td", { staticClass: "table-index" }, [_vm._v("52")]),
              _c("td", [
                _vm._v(
                  "\n            Có tự động khóa các khoản lương khi đã thanh toán đủ không?\n          "
                ),
              ]),
              _c(
                "td",
                { staticClass: "table-action" },
                [
                  _c(
                    "el-radio-group",
                    {
                      model: {
                        value:
                          _vm.schoolConfigInSysResponse.autoLockSalarySuccess,
                        callback: function ($$v) {
                          _vm.$set(
                            _vm.schoolConfigInSysResponse,
                            "autoLockSalarySuccess",
                            $$v
                          )
                        },
                        expression:
                          "schoolConfigInSysResponse.autoLockSalarySuccess",
                      },
                    },
                    [
                      _c("el-radio", { attrs: { label: true } }, [
                        _vm._v("Có"),
                      ]),
                      _c("el-radio", { attrs: { label: false } }, [
                        _vm._v("Không"),
                      ]),
                    ],
                    1
                  ),
                ],
                1
              ),
            ]),
            _c("tr", [
              _c("td", { staticClass: "table-index" }, [_vm._v("53")]),
              _c("td", [
                _vm._v(
                  "\n            Có tự động hiển thị hóa đơn lương của cả tháng khi hóa đơn đã\n            được sinh ra không?\n          "
                ),
              ]),
              _c(
                "td",
                { staticClass: "table-action" },
                [
                  _c(
                    "el-radio-group",
                    {
                      model: {
                        value:
                          _vm.schoolConfigInSysResponse.autoShowBillOfMonth,
                        callback: function ($$v) {
                          _vm.$set(
                            _vm.schoolConfigInSysResponse,
                            "autoShowBillOfMonth",
                            $$v
                          )
                        },
                        expression:
                          "schoolConfigInSysResponse.autoShowBillOfMonth",
                      },
                    },
                    [
                      _c("el-radio", { attrs: { label: true } }, [
                        _vm._v("Có"),
                      ]),
                      _c("el-radio", { attrs: { label: false } }, [
                        _vm._v("Không"),
                      ]),
                    ],
                    1
                  ),
                ],
                1
              ),
            ]),
            _c("tr", [
              _c("td", { staticClass: "table-index" }, [_vm._v("54")]),
              _c("td", [
                _vm._v(
                  "\n            Có sinh tự động hóa đơn học phí của học sinh cho tháng tiếp theo\n            không (sinh tự động vào ngày đầu tháng)?\n          "
                ),
              ]),
              _c(
                "td",
                { staticClass: "table-action" },
                [
                  _c(
                    "el-radio-group",
                    {
                      model: {
                        value:
                          _vm.schoolConfigInSysResponse.autoFeesApprovedKids,
                        callback: function ($$v) {
                          _vm.$set(
                            _vm.schoolConfigInSysResponse,
                            "autoFeesApprovedKids",
                            $$v
                          )
                        },
                        expression:
                          "schoolConfigInSysResponse.autoFeesApprovedKids",
                      },
                    },
                    [
                      _c("el-radio", { attrs: { label: true } }, [
                        _vm._v("Có"),
                      ]),
                      _c("el-radio", { attrs: { label: false } }, [
                        _vm._v("Không"),
                      ]),
                    ],
                    1
                  ),
                ],
                1
              ),
            ]),
            _c("tr", [
              _c("td", { staticClass: "table-index" }, [_vm._v("55")]),
              _c("td", [
                _vm._v(
                  "\n            Có sinh tự động các khoản thu với học sinh theo các khoản thu đã\n            đăng ký?\n          "
                ),
              ]),
              _c(
                "td",
                { staticClass: "table-action" },
                [
                  _c(
                    "el-radio-group",
                    {
                      model: {
                        value:
                          _vm.schoolConfigInSysResponse.autoGenerateFeesKids,
                        callback: function ($$v) {
                          _vm.$set(
                            _vm.schoolConfigInSysResponse,
                            "autoGenerateFeesKids",
                            $$v
                          )
                        },
                        expression:
                          "schoolConfigInSysResponse.autoGenerateFeesKids",
                      },
                    },
                    [
                      _c("el-radio", { attrs: { label: true } }, [
                        _vm._v("Có"),
                      ]),
                      _c("el-radio", { attrs: { label: false } }, [
                        _vm._v("Không"),
                      ]),
                    ],
                    1
                  ),
                ],
                1
              ),
            ]),
            _c("tr", [
              _c("td", { staticClass: "table-index" }, [_vm._v("56")]),
              _c("td", [
                _vm._v(
                  "\n            Thiết lập ngày của tháng sẽ sinh tự động các khoản thu cho học\n            sinh?\n          "
                ),
              ]),
              _c(
                "td",
                { staticClass: "table-action" },
                [
                  _c("el-input-number", {
                    attrs: {
                      disabled:
                        !_vm.schoolConfigInSysResponse.autoGenerateFeesKids,
                      size: "mini",
                      min: 1,
                      max: 31,
                    },
                    model: {
                      value: _vm.schoolConfigInSysResponse.autoNexMonthFeesDate,
                      callback: function ($$v) {
                        _vm.$set(
                          _vm.schoolConfigInSysResponse,
                          "autoNexMonthFeesDate",
                          $$v
                        )
                      },
                      expression:
                        "schoolConfigInSysResponse.autoNexMonthFeesDate",
                    },
                  }),
                ],
                1
              ),
            ]),
            _c("tr", [
              _c("td", { staticClass: "table-index" }, [_vm._v("57")]),
              _c("td", [
                _vm._v(
                  "\n            Có tự động duyệt các khoản thu của học sinh hàng tháng không?\n          "
                ),
              ]),
              _c(
                "td",
                { staticClass: "table-action" },
                [
                  _c(
                    "el-radio-group",
                    {
                      model: {
                        value:
                          _vm.schoolConfigInSysResponse
                            .autoApprovedFeesMonthKids,
                        callback: function ($$v) {
                          _vm.$set(
                            _vm.schoolConfigInSysResponse,
                            "autoApprovedFeesMonthKids",
                            $$v
                          )
                        },
                        expression:
                          "schoolConfigInSysResponse.autoApprovedFeesMonthKids",
                      },
                    },
                    [
                      _c("el-radio", { attrs: { label: true } }, [
                        _vm._v("Có"),
                      ]),
                      _c("el-radio", { attrs: { label: false } }, [
                        _vm._v("Không"),
                      ]),
                    ],
                    1
                  ),
                ],
                1
              ),
            ]),
            _c("tr", [
              _c("td", { staticClass: "table-index" }, [_vm._v("58")]),
              _c("td", [
                _vm._v(
                  "\n            Có tự động khóa các khoản thu khi Phụ huynh đã thanh toán đủ\n            không?\n          "
                ),
              ]),
              _c(
                "td",
                { staticClass: "table-action" },
                [
                  _c(
                    "el-radio-group",
                    {
                      model: {
                        value:
                          _vm.schoolConfigInSysResponse.autoLockFeesSuccessKids,
                        callback: function ($$v) {
                          _vm.$set(
                            _vm.schoolConfigInSysResponse,
                            "autoLockFeesSuccessKids",
                            $$v
                          )
                        },
                        expression:
                          "schoolConfigInSysResponse.autoLockFeesSuccessKids",
                      },
                    },
                    [
                      _c("el-radio", { attrs: { label: true } }, [
                        _vm._v("Có"),
                      ]),
                      _c("el-radio", { attrs: { label: false } }, [
                        _vm._v("Không"),
                      ]),
                    ],
                    1
                  ),
                ],
                1
              ),
            ]),
            _c("tr", [
              _c("td", { staticClass: "table-index" }, [_vm._v("59")]),
              _c("td", [
                _vm._v(
                  "\n            Có tự động hiển thị hóa đơn học phí của cả tháng khi hóa đơn đã\n            được sinh ra không?\n          "
                ),
              ]),
              _c(
                "td",
                { staticClass: "table-action" },
                [
                  _c(
                    "el-radio-group",
                    {
                      model: {
                        value: _vm.schoolConfigInSysResponse.autoShowFeesMonth,
                        callback: function ($$v) {
                          _vm.$set(
                            _vm.schoolConfigInSysResponse,
                            "autoShowFeesMonth",
                            $$v
                          )
                        },
                        expression:
                          "schoolConfigInSysResponse.autoShowFeesMonth",
                      },
                    },
                    [
                      _c("el-radio", { attrs: { label: true } }, [
                        _vm._v("Có"),
                      ]),
                      _c("el-radio", { attrs: { label: false } }, [
                        _vm._v("Không"),
                      ]),
                    ],
                    1
                  ),
                ],
                1
              ),
            ]),
            _c("tr", [
              _c("td", { staticClass: "table-index" }, [_vm._v("60")]),
              _c("td", [
                _vm._v(
                  "\n            Có hiển thị thông tin các khoản thu dự kiến cho Phụ huynh học\n            sinh không?\n          "
                ),
              ]),
              _c(
                "td",
                { staticClass: "table-action" },
                [
                  _c(
                    "el-radio-group",
                    {
                      model: {
                        value:
                          _vm.schoolConfigInSysResponse.autoShowFeesFutureKids,
                        callback: function ($$v) {
                          _vm.$set(
                            _vm.schoolConfigInSysResponse,
                            "autoShowFeesFutureKids",
                            $$v
                          )
                        },
                        expression:
                          "schoolConfigInSysResponse.autoShowFeesFutureKids",
                      },
                    },
                    [
                      _c("el-radio", { attrs: { label: true } }, [
                        _vm._v("Có"),
                      ]),
                      _c("el-radio", { attrs: { label: false } }, [
                        _vm._v("Không"),
                      ]),
                    ],
                    1
                  ),
                ],
                1
              ),
            ]),
            _c("tr", [
              _c("td", { staticClass: "table-index" }, [_vm._v("61")]),
              _c("td", [
                _vm._v("Có cho phép Phụ huynh truy cập ví hay không?"),
              ]),
              _c(
                "td",
                { staticClass: "table-action" },
                [
                  _c(
                    "el-radio-group",
                    {
                      model: {
                        value: _vm.schoolConfigInSysResponse.showWalletParent,
                        callback: function ($$v) {
                          _vm.$set(
                            _vm.schoolConfigInSysResponse,
                            "showWalletParent",
                            $$v
                          )
                        },
                        expression:
                          "schoolConfigInSysResponse.showWalletParent",
                      },
                    },
                    [
                      _c("el-radio", { attrs: { label: true } }, [
                        _vm._v("Có"),
                      ]),
                      _c("el-radio", { attrs: { label: false } }, [
                        _vm._v("Không"),
                      ]),
                    ],
                    1
                  ),
                ],
                1
              ),
            ]),
            _c("tr", [
              _c("td", { staticClass: "table-index" }, [_vm._v("62")]),
              _c("td", [
                _vm._v(
                  "\n            Có hiển thị thông tin khoản thu dự kiến của học sinh cho Giáo\n            viên không?\n          "
                ),
              ]),
              _c(
                "td",
                { staticClass: "table-action" },
                [
                  _c(
                    "el-radio-group",
                    {
                      model: {
                        value:
                          _vm.schoolConfigInSysResponse
                            .autoShowFeesFutureKidsForTeacher,
                        callback: function ($$v) {
                          _vm.$set(
                            _vm.schoolConfigInSysResponse,
                            "autoShowFeesFutureKidsForTeacher",
                            $$v
                          )
                        },
                        expression:
                          "schoolConfigInSysResponse.autoShowFeesFutureKidsForTeacher",
                      },
                    },
                    [
                      _c("el-radio", { attrs: { label: true } }, [
                        _vm._v("Có"),
                      ]),
                      _c("el-radio", { attrs: { label: false } }, [
                        _vm._v("Không"),
                      ]),
                    ],
                    1
                  ),
                ],
                1
              ),
            ]),
            _c("tr", [
              _c("td", { staticClass: "table-index" }, [_vm._v("63")]),
              _c("td", [
                _vm._v("Hiển thị nút xóa nhân sự, học sinh hay không?"),
              ]),
              _c(
                "td",
                { staticClass: "table-action" },
                [
                  _c(
                    "el-radio-group",
                    {
                      model: {
                        value: _vm.schoolConfigInSysResponse.deleteStatus,
                        callback: function ($$v) {
                          _vm.$set(
                            _vm.schoolConfigInSysResponse,
                            "deleteStatus",
                            $$v
                          )
                        },
                        expression: "schoolConfigInSysResponse.deleteStatus",
                      },
                    },
                    [
                      _c("el-radio", { attrs: { label: true } }, [
                        _vm._v("Có"),
                      ]),
                      _c("el-radio", { attrs: { label: false } }, [
                        _vm._v("Không"),
                      ]),
                    ],
                    1
                  ),
                ],
                1
              ),
            ]),
            _c("tr", [
              _c("td", { staticClass: "table-index" }, [_vm._v("64")]),
              _c("td", [_vm._v("Mã xử lý trùng tài khoản")]),
              _c(
                "td",
                { staticClass: "table-action" },
                [
                  _c("el-input", {
                    attrs: { size: "mini", maxlength: 6 },
                    model: {
                      value: _vm.schoolConfigInSysResponse.verifyCode,
                      callback: function ($$v) {
                        _vm.$set(
                          _vm.schoolConfigInSysResponse,
                          "verifyCode",
                          $$v
                        )
                      },
                      expression: "schoolConfigInSysResponse.verifyCode",
                    },
                  }),
                ],
                1
              ),
            ]),
            _c("tr", [
              _c("td", { staticClass: "table-index" }, [_vm._v("65")]),
              _c("td", [
                _vm._v(
                  "\n            Có cho phép ra trường, nghỉ học khi chưa hoàn thành học phí\n            không?\n          "
                ),
              ]),
              _c(
                "td",
                { staticClass: "table-action" },
                [
                  _c(
                    "el-radio-group",
                    {
                      model: {
                        value:
                          _vm.schoolConfigInSysResponse.checkCompleteFeesStatus,
                        callback: function ($$v) {
                          _vm.$set(
                            _vm.schoolConfigInSysResponse,
                            "checkCompleteFeesStatus",
                            $$v
                          )
                        },
                        expression:
                          "schoolConfigInSysResponse.checkCompleteFeesStatus",
                      },
                    },
                    [
                      _c("el-radio", { attrs: { label: true } }, [
                        _vm._v("Có"),
                      ]),
                      _c("el-radio", { attrs: { label: false } }, [
                        _vm._v("Không"),
                      ]),
                    ],
                    1
                  ),
                ],
                1
              ),
            ]),
            _c("tr", [
              _c("td", { staticClass: "table-index" }, [_vm._v("66")]),
              _c("td", [
                _vm._v("Có gửi thông báo khi Nhà trường rút tiền từ ví không?"),
              ]),
              _c(
                "td",
                { staticClass: "table-action" },
                [
                  _c(
                    "el-radio-group",
                    {
                      model: {
                        value:
                          _vm.schoolConfigInSysResponse.notifyWalletOutStatus,
                        callback: function ($$v) {
                          _vm.$set(
                            _vm.schoolConfigInSysResponse,
                            "notifyWalletOutStatus",
                            $$v
                          )
                        },
                        expression:
                          "schoolConfigInSysResponse.notifyWalletOutStatus",
                      },
                    },
                    [
                      _c("el-radio", { attrs: { label: true } }, [
                        _vm._v("Có"),
                      ]),
                      _c("el-radio", { attrs: { label: false } }, [
                        _vm._v("Không"),
                      ]),
                    ],
                    1
                  ),
                ],
                1
              ),
            ]),
            _c("tr", [
              _c("td", { staticClass: "table-index" }, [_vm._v("67")]),
              _c("td", [
                _vm._v("Hiện OneCam Plus trong danh sách Camera Nhà trường?"),
              ]),
              _c(
                "td",
                { staticClass: "table-action" },
                [
                  _c(
                    "el-radio-group",
                    {
                      model: {
                        value: _vm.schoolConfigInSysResponse.showOnecamPlus,
                        callback: function ($$v) {
                          _vm.$set(
                            _vm.schoolConfigInSysResponse,
                            "showOnecamPlus",
                            $$v
                          )
                        },
                        expression: "schoolConfigInSysResponse.showOnecamPlus",
                      },
                    },
                    [
                      _c("el-radio", { attrs: { label: true } }, [
                        _vm._v("Có"),
                      ]),
                      _c("el-radio", { attrs: { label: false } }, [
                        _vm._v("Không"),
                      ]),
                    ],
                    1
                  ),
                ],
                1
              ),
            ]),
            _c("tr", [
              _c("td", { staticClass: "table-index" }, [_vm._v("68")]),
              _c("td", [_vm._v("Số lượng ảnh tối đa khi đăng Album")]),
              _c(
                "td",
                { staticClass: "table-action" },
                [
                  _c("el-input", {
                    attrs: { size: "mini" },
                    model: {
                      value: _vm.schoolConfigInSysResponse.albumMaxNumber,
                      callback: function ($$v) {
                        _vm.$set(
                          _vm.schoolConfigInSysResponse,
                          "albumMaxNumber",
                          $$v
                        )
                      },
                      expression: "schoolConfigInSysResponse.albumMaxNumber",
                    },
                  }),
                ],
                1
              ),
            ]),
            _c("tr", [
              _c("td", { staticClass: "table-index" }, [_vm._v("70")]),
              _c("td", [
                _vm._v("Áp dụng tự động điền điểm danh ăn sáng theo đi học?"),
              ]),
              _c(
                "td",
                { staticClass: "table-action" },
                [
                  _c(
                    "el-radio-group",
                    {
                      model: {
                        value: _vm.schoolConfigInSysResponse.breakfastAuto,
                        callback: function ($$v) {
                          _vm.$set(
                            _vm.schoolConfigInSysResponse,
                            "breakfastAuto",
                            $$v
                          )
                        },
                        expression: "schoolConfigInSysResponse.breakfastAuto",
                      },
                    },
                    [
                      _c("el-radio", { attrs: { label: true } }, [
                        _vm._v("Có"),
                      ]),
                      _c("el-radio", { attrs: { label: false } }, [
                        _vm._v("Không"),
                      ]),
                    ],
                    1
                  ),
                ],
                1
              ),
            ]),
            _c("tr", [
              _c("td", { staticClass: "table-index" }, [_vm._v("71")]),
              _c("td", [
                _vm._v(
                  "Áp dụng tự động điền điểm danh ăn phụ sáng theo đi học?"
                ),
              ]),
              _c(
                "td",
                { staticClass: "table-action" },
                [
                  _c(
                    "el-radio-group",
                    {
                      model: {
                        value:
                          _vm.schoolConfigInSysResponse.secondBreakfastAuto,
                        callback: function ($$v) {
                          _vm.$set(
                            _vm.schoolConfigInSysResponse,
                            "secondBreakfastAuto",
                            $$v
                          )
                        },
                        expression:
                          "schoolConfigInSysResponse.secondBreakfastAuto",
                      },
                    },
                    [
                      _c("el-radio", { attrs: { label: true } }, [
                        _vm._v("Có"),
                      ]),
                      _c("el-radio", { attrs: { label: false } }, [
                        _vm._v("Không"),
                      ]),
                    ],
                    1
                  ),
                ],
                1
              ),
            ]),
            _c("tr", [
              _c("td", { staticClass: "table-index" }, [_vm._v("72")]),
              _c("td", [
                _vm._v("Áp dụng tự động điền điểm danh ăn trưa theo đi học?"),
              ]),
              _c(
                "td",
                { staticClass: "table-action" },
                [
                  _c(
                    "el-radio-group",
                    {
                      model: {
                        value: _vm.schoolConfigInSysResponse.lunchAuto,
                        callback: function ($$v) {
                          _vm.$set(
                            _vm.schoolConfigInSysResponse,
                            "lunchAuto",
                            $$v
                          )
                        },
                        expression: "schoolConfigInSysResponse.lunchAuto",
                      },
                    },
                    [
                      _c("el-radio", { attrs: { label: true } }, [
                        _vm._v("Có"),
                      ]),
                      _c("el-radio", { attrs: { label: false } }, [
                        _vm._v("Không"),
                      ]),
                    ],
                    1
                  ),
                ],
                1
              ),
            ]),
            _c("tr", [
              _c("td", { staticClass: "table-index" }, [_vm._v("73")]),
              _c("td", [
                _vm._v("Áp dụng tự động điền điểm danh ăn chiều theo đi học?"),
              ]),
              _c(
                "td",
                { staticClass: "table-action" },
                [
                  _c(
                    "el-radio-group",
                    {
                      model: {
                        value: _vm.schoolConfigInSysResponse.afternoonAuto,
                        callback: function ($$v) {
                          _vm.$set(
                            _vm.schoolConfigInSysResponse,
                            "afternoonAuto",
                            $$v
                          )
                        },
                        expression: "schoolConfigInSysResponse.afternoonAuto",
                      },
                    },
                    [
                      _c("el-radio", { attrs: { label: true } }, [
                        _vm._v("Có"),
                      ]),
                      _c("el-radio", { attrs: { label: false } }, [
                        _vm._v("Không"),
                      ]),
                    ],
                    1
                  ),
                ],
                1
              ),
            ]),
            _c("tr", [
              _c("td", { staticClass: "table-index" }, [_vm._v("74")]),
              _c("td", [
                _vm._v(
                  "Áp dụng tự động điền điểm danh ăn phụ chiều theo đi học?"
                ),
              ]),
              _c(
                "td",
                { staticClass: "table-action" },
                [
                  _c(
                    "el-radio-group",
                    {
                      model: {
                        value:
                          _vm.schoolConfigInSysResponse.secondAfternoonAuto,
                        callback: function ($$v) {
                          _vm.$set(
                            _vm.schoolConfigInSysResponse,
                            "secondAfternoonAuto",
                            $$v
                          )
                        },
                        expression:
                          "schoolConfigInSysResponse.secondAfternoonAuto",
                      },
                    },
                    [
                      _c("el-radio", { attrs: { label: true } }, [
                        _vm._v("Có"),
                      ]),
                      _c("el-radio", { attrs: { label: false } }, [
                        _vm._v("Không"),
                      ]),
                    ],
                    1
                  ),
                ],
                1
              ),
            ]),
            _c("tr", [
              _c("td", { staticClass: "table-index" }, [_vm._v("75")]),
              _c("td", [
                _vm._v("Áp dụng tự động điền điểm danh ăn tối theo đi học?"),
              ]),
              _c(
                "td",
                { staticClass: "table-action" },
                [
                  _c(
                    "el-radio-group",
                    {
                      model: {
                        value: _vm.schoolConfigInSysResponse.dinnerAuto,
                        callback: function ($$v) {
                          _vm.$set(
                            _vm.schoolConfigInSysResponse,
                            "dinnerAuto",
                            $$v
                          )
                        },
                        expression: "schoolConfigInSysResponse.dinnerAuto",
                      },
                    },
                    [
                      _c("el-radio", { attrs: { label: true } }, [
                        _vm._v("Có"),
                      ]),
                      _c("el-radio", { attrs: { label: false } }, [
                        _vm._v("Không"),
                      ]),
                    ],
                    1
                  ),
                ],
                1
              ),
            ]),
            _c("tr", [
              _c("td", { staticClass: "table-index" }, [_vm._v("76")]),
              _c("td", [
                _vm._v(
                  "Có tự động tạo điểm danh khi học sinh xin nghỉ học quá thời hạn quy định hay không?"
                ),
              ]),
              _c(
                "td",
                { staticClass: "table-action" },
                [
                  _c(
                    "el-radio-group",
                    {
                      model: {
                        value:
                          _vm.schoolConfigInSysResponse.attendanceCreateLetter,
                        callback: function ($$v) {
                          _vm.$set(
                            _vm.schoolConfigInSysResponse,
                            "attendanceCreateLetter",
                            $$v
                          )
                        },
                        expression:
                          "schoolConfigInSysResponse.attendanceCreateLetter",
                      },
                    },
                    [
                      _c("el-radio", { attrs: { label: true } }, [
                        _vm._v("Có"),
                      ]),
                      _c("el-radio", { attrs: { label: false } }, [
                        _vm._v("Không"),
                      ]),
                    ],
                    1
                  ),
                ],
                1
              ),
            ]),
            _c("tr", [
              _c("td", { staticClass: "table-index" }, [_vm._v("77")]),
              _c("td", [
                _vm._v(
                  "Chọn trạng thái điểm danh mặc định khi xin nghỉ quá thời hạn?"
                ),
              ]),
              _c(
                "td",
                { staticClass: "table-action" },
                [
                  _c(
                    "el-radio-group",
                    {
                      model: {
                        value: _vm.schoolConfigInSysResponse.absentYesNoLetter,
                        callback: function ($$v) {
                          _vm.$set(
                            _vm.schoolConfigInSysResponse,
                            "absentYesNoLetter",
                            $$v
                          )
                        },
                        expression:
                          "schoolConfigInSysResponse.absentYesNoLetter",
                      },
                    },
                    [
                      _c("el-radio", { attrs: { label: true } }, [
                        _vm._v("Có phép"),
                      ]),
                      _c("el-radio", { attrs: { label: false } }, [
                        _vm._v("Không phép"),
                      ]),
                    ],
                    1
                  ),
                ],
                1
              ),
            ]),
            _c("tr", { staticClass: "disable-row" }, [
              _c("td", { staticClass: "table-index" }, [_vm._v("78")]),
              _c("td", [_vm._v("Thời gian gửi lời chúc mừng mặc định?")]),
              _c("td", { staticClass: "table-action" }, [
                _c("span", [
                  _vm._v(
                    _vm._s(
                      _vm._f("formatTime")(
                        _vm.sysConfigResponse.timeSendCelebrate
                      )
                    )
                  ),
                ]),
              ]),
            ]),
            _c("tr", { staticClass: "disable-row" }, [
              _c("td", { staticClass: "table-index" }, [_vm._v("79")]),
              _c("td", [_vm._v("Chất lượng ảnh theo %?")]),
              _c("td", { staticClass: "table-action" }, [
                _c("span", [
                  _vm._v(_vm._s(_vm.sysConfigResponse.qualityPicture)),
                ]),
              ]),
            ]),
            _c("tr", { staticClass: "disable-row" }, [
              _c("td", { staticClass: "table-index" }, [_vm._v("80")]),
              _c("td", [_vm._v("Chất lượng ảnh theo kích thước?")]),
              _c("td", { staticClass: "table-action" }, [
                _c("span", [
                  _vm._v(_vm._s(_vm.sysConfigResponse.widthPicture)),
                ]),
              ]),
            ]),
            _c("tr", { staticClass: "disable-row" }, [
              _c("td", { staticClass: "table-index" }, [_vm._v("81")]),
              _c("td", [_vm._v("Chèn tiêu đề vào nội dung tin nhắn?")]),
              _c("td", { staticClass: "table-action" }, [
                _vm.sysConfigResponse.showTitleSms
                  ? _c("span", [_vm._v("Có")])
                  : _c("span", [_vm._v("Không")]),
              ]),
            ]),
            _c("tr", [
              _c("td", { staticClass: "table-index disable-row" }, [
                _vm._v("82"),
              ]),
              _c("td", { staticClass: "disable-row" }, [
                _vm._v(
                  "\n            Nội dung tiêu đề mặc định trong tin nhắn SMS?\n          "
                ),
              ]),
              _c(
                "td",
                { staticClass: "table-action" },
                [
                  _c("el-popover", {
                    attrs: {
                      placement: "top-start",
                      title: "Nội dung tiêu đề",
                      width: "300",
                      trigger: "hover",
                      content: _vm.sysConfigResponse.titleContentSms,
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "reference",
                        fn: function () {
                          return [
                            _c("el-button", { attrs: { type: "text" } }, [
                              _vm._v("Xem"),
                            ]),
                          ]
                        },
                        proxy: true,
                      },
                    ]),
                  }),
                ],
                1
              ),
            ]),
            _c("tr", [
              _c("td", { staticClass: "table-index" }, [_vm._v("83")]),
              _c("td", [_vm._v("Thiết lập thời gian đón muộn")]),
              _c("td", { staticClass: "table-action" }, [
                _c("table", { staticClass: "center-table" }, [
                  _c("tr", [
                    _c(
                      "td",
                      [
                        _c(
                          "el-radio-group",
                          {
                            model: {
                              value: _vm.schoolConfigInSysResponse.statusBlock,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.schoolConfigInSysResponse,
                                  "statusBlock",
                                  $$v
                                )
                              },
                              expression:
                                "schoolConfigInSysResponse.statusBlock",
                            },
                          },
                          [
                            _c("el-radio", { attrs: { label: true } }, [
                              _vm._v("Block"),
                            ]),
                            _c("el-radio", { attrs: { label: false } }, [
                              _vm._v("Ngày"),
                            ]),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ]),
                  _c("tr", [
                    _c(
                      "td",
                      [
                        _c(
                          "span",
                          { staticStyle: { "margin-right": "20px" } },
                          [_vm._v("Nhập số phút")]
                        ),
                        _c(
                          "el-input-number",
                          {
                            staticStyle: { width: "150px" },
                            attrs: {
                              size: "small",
                              min: 0,
                              step: 1,
                              placeholder: "Nhập số phút",
                            },
                            model: {
                              value:
                                _vm.schoolConfigInSysResponse.blockLeaveKid,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.schoolConfigInSysResponse,
                                  "blockLeaveKid",
                                  $$v
                                )
                              },
                              expression:
                                "schoolConfigInSysResponse.blockLeaveKid",
                            },
                          },
                          [
                            _vm._v(
                              "\n                    >\n                  "
                            ),
                          ]
                        ),
                      ],
                      1
                    ),
                  ]),
                  _c("tr", [
                    _c(
                      "td",
                      [
                        _c(
                          "el-radio-group",
                          {
                            model: {
                              value: _vm.schoolConfigInSysResponse.statusUpDown,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.schoolConfigInSysResponse,
                                  "statusUpDown",
                                  $$v
                                )
                              },
                              expression:
                                "schoolConfigInSysResponse.statusUpDown",
                            },
                          },
                          [
                            _c("el-radio", { attrs: { label: true } }, [
                              _vm._v("Làm tròn lên"),
                            ]),
                            _c("el-radio", { attrs: { label: false } }, [
                              _vm._v("Làm tròn xuống"),
                            ]),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ]),
                ]),
              ]),
            ]),
            _c("tr", [
              _c("td", { staticClass: "table-index" }, [_vm._v("84")]),
              _c("td", [
                _vm._v("Cấu hình thứ tự hiển thị tin tức màn Home trên App?"),
              ]),
              _c("td", [
                _c("div", { staticClass: "sttShowTabHomeTable" }, [
                  _c("table", [
                    _vm._m(1),
                    _c("tr", [
                      _c(
                        "td",
                        { staticStyle: { "text-align": "center" } },
                        [
                          _c("el-checkbox", {
                            attrs: { disabled: true },
                            model: {
                              value:
                                _vm.schoolConfigInSysResponse.activeShowNews,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.schoolConfigInSysResponse,
                                  "activeShowNews",
                                  $$v
                                )
                              },
                              expression:
                                "schoolConfigInSysResponse.activeShowNews",
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "td",
                        { staticStyle: { "text-align": "center" } },
                        [
                          _c("el-checkbox", {
                            on: { change: _vm.changeShowFacebook },
                            model: {
                              value:
                                _vm.schoolConfigInSysResponse
                                  .activeShowFacebook,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.schoolConfigInSysResponse,
                                  "activeShowFacebook",
                                  $$v
                                )
                              },
                              expression:
                                "schoolConfigInSysResponse.activeShowFacebook",
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "td",
                        { staticStyle: { "text-align": "center" } },
                        [
                          _c("el-checkbox", {
                            on: { change: _vm.changeShowVideo },
                            model: {
                              value:
                                _vm.schoolConfigInSysResponse.activeShowVideo,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.schoolConfigInSysResponse,
                                  "activeShowVideo",
                                  $$v
                                )
                              },
                              expression:
                                "schoolConfigInSysResponse.activeShowVideo",
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "td",
                        { staticStyle: { "text-align": "center" } },
                        [
                          _c("el-checkbox", {
                            on: { change: _vm.changeShowWebsiteSchool },
                            model: {
                              value:
                                _vm.schoolConfigInSysResponse
                                  .activeShowWebsiteSchool,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.schoolConfigInSysResponse,
                                  "activeShowWebsiteSchool",
                                  $$v
                                )
                              },
                              expression:
                                "schoolConfigInSysResponse.activeShowWebsiteSchool",
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "td",
                        { staticStyle: { "text-align": "center" } },
                        [
                          _c("el-checkbox", {
                            on: { change: _vm.changeShowTiktok },
                            model: {
                              value:
                                _vm.schoolConfigInSysResponse.activeShowTiktok,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.schoolConfigInSysResponse,
                                  "activeShowTiktok",
                                  $$v
                                )
                              },
                              expression:
                                "schoolConfigInSysResponse.activeShowTiktok",
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "td",
                        { staticStyle: { "text-align": "center" } },
                        [
                          _c("el-checkbox", {
                            on: { change: _vm.changeShowOneKidsPage },
                            model: {
                              value:
                                _vm.schoolConfigInSysResponse
                                  .activeShowOneKidsPage,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.schoolConfigInSysResponse,
                                  "activeShowOneKidsPage",
                                  $$v
                                )
                              },
                              expression:
                                "schoolConfigInSysResponse.activeShowOneKidsPage",
                            },
                          }),
                        ],
                        1
                      ),
                    ]),
                    _c("tr", [
                      _c(
                        "td",
                        [
                          _c(
                            "el-select",
                            {
                              staticClass: "input-common",
                              attrs: {
                                placeholder: "Chọn thứ tự hiển thị tin tức",
                              },
                              on: { change: _vm.changeNumberShowNews },
                              model: {
                                value:
                                  _vm.schoolConfigInSysResponse.sttShowNews,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.schoolConfigInSysResponse,
                                    "sttShowNews",
                                    $$v
                                  )
                                },
                                expression:
                                  "schoolConfigInSysResponse.sttShowNews",
                              },
                            },
                            _vm._l(_vm.numberSelect, function (item) {
                              return _c("el-option", {
                                key: item,
                                attrs: {
                                  disabled:
                                    item ===
                                    _vm.schoolConfigInSysResponse.sttShowNews,
                                  value: item,
                                  label: `${item}`,
                                },
                              })
                            }),
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "td",
                        [
                          _c(
                            "el-select",
                            {
                              staticClass: "input-common",
                              attrs: {
                                placeholder: "Chọn thứ tự hiển thị Facebook",
                                disabled:
                                  !_vm.schoolConfigInSysResponse
                                    .activeShowFacebook,
                              },
                              on: { change: _vm.changeNumberShowFacebook },
                              model: {
                                value:
                                  _vm.schoolConfigInSysResponse.sttShowFacebook,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.schoolConfigInSysResponse,
                                    "sttShowFacebook",
                                    $$v
                                  )
                                },
                                expression:
                                  "schoolConfigInSysResponse.sttShowFacebook",
                              },
                            },
                            _vm._l(_vm.numberSelect, function (item) {
                              return _c("el-option", {
                                key: item,
                                attrs: {
                                  disabled:
                                    item ===
                                    _vm.schoolConfigInSysResponse
                                      .sttShowFacebook,
                                  value: item,
                                  label: `${item}`,
                                },
                              })
                            }),
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "td",
                        [
                          _c(
                            "el-select",
                            {
                              staticClass: "input-common",
                              attrs: {
                                placeholder: "Chọn thứ tự hiển thị Video",
                                disabled:
                                  !_vm.schoolConfigInSysResponse
                                    .activeShowVideo,
                              },
                              on: { change: _vm.changeNumberShowVideo },
                              model: {
                                value:
                                  _vm.schoolConfigInSysResponse.sttShowVideo,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.schoolConfigInSysResponse,
                                    "sttShowVideo",
                                    $$v
                                  )
                                },
                                expression:
                                  "schoolConfigInSysResponse.sttShowVideo",
                              },
                            },
                            _vm._l(_vm.numberSelect, function (item) {
                              return _c("el-option", {
                                key: item,
                                attrs: {
                                  disabled:
                                    item ===
                                    _vm.schoolConfigInSysResponse.sttShowVideo,
                                  value: item,
                                  label: `${item}`,
                                },
                              })
                            }),
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "td",
                        [
                          _c(
                            "el-select",
                            {
                              staticClass: "input-common",
                              attrs: {
                                placeholder:
                                  "Chọn thứ tự hiển thị trang web của trường",
                                disabled:
                                  !_vm.schoolConfigInSysResponse
                                    .activeShowWebsiteSchool,
                              },
                              on: { change: _vm.changeNumberShowWebsiteSchool },
                              model: {
                                value:
                                  _vm.schoolConfigInSysResponse
                                    .sttShowWebsiteSchool,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.schoolConfigInSysResponse,
                                    "sttShowWebsiteSchool",
                                    $$v
                                  )
                                },
                                expression:
                                  "schoolConfigInSysResponse.sttShowWebsiteSchool",
                              },
                            },
                            _vm._l(_vm.numberSelect, function (item) {
                              return _c("el-option", {
                                key: item,
                                attrs: {
                                  disabled:
                                    item ===
                                    _vm.schoolConfigInSysResponse
                                      .sttShowWebsiteSchool,
                                  value: item,
                                  label: `${item}`,
                                },
                              })
                            }),
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "td",
                        [
                          _c(
                            "el-select",
                            {
                              staticClass: "input-common",
                              attrs: {
                                placeholder: "Chọn thứ tự hiển thị Tiktok",
                                disabled:
                                  !_vm.schoolConfigInSysResponse
                                    .activeShowTiktok,
                              },
                              on: { change: _vm.changeNumberShowTiktok },
                              model: {
                                value:
                                  _vm.schoolConfigInSysResponse.sttShowTiktok,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.schoolConfigInSysResponse,
                                    "sttShowTiktok",
                                    $$v
                                  )
                                },
                                expression:
                                  "schoolConfigInSysResponse.sttShowTiktok",
                              },
                            },
                            _vm._l(_vm.numberSelect, function (item) {
                              return _c("el-option", {
                                key: item,
                                attrs: {
                                  disabled:
                                    item ===
                                    _vm.schoolConfigInSysResponse.sttShowTiktok,
                                  value: item,
                                  label: `${item}`,
                                },
                              })
                            }),
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "td",
                        [
                          _c(
                            "el-select",
                            {
                              staticClass: "input-common",
                              attrs: {
                                placeholder:
                                  "Chọn thứ tự hiển thị trang web của Onekids",
                                disabled:
                                  !_vm.schoolConfigInSysResponse
                                    .activeShowOneKidsPage,
                              },
                              on: { change: _vm.changeNumberShowOneKidsPage },
                              model: {
                                value:
                                  _vm.schoolConfigInSysResponse
                                    .sttShowOneKidsPage,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.schoolConfigInSysResponse,
                                    "sttShowOneKidsPage",
                                    $$v
                                  )
                                },
                                expression:
                                  "schoolConfigInSysResponse.sttShowOneKidsPage",
                              },
                            },
                            _vm._l(_vm.numberSelect, function (item) {
                              return _c("el-option", {
                                key: item,
                                attrs: {
                                  disabled:
                                    item ===
                                    _vm.schoolConfigInSysResponse
                                      .sttShowOneKidsPage,
                                  value: item,
                                  label: `${item}`,
                                },
                              })
                            }),
                            1
                          ),
                        ],
                        1
                      ),
                    ]),
                  ]),
                ]),
              ]),
            ]),
            _c("tr", [
              _c("td", { staticClass: "table-index" }, [_vm._v("85")]),
              _c("td", [
                _vm._v(
                  "Có tự động xóa dữ liệu điểm danh, nhận xét trùng hay không?"
                ),
              ]),
              _c(
                "td",
                { staticClass: "table-action" },
                [
                  _c(
                    "el-radio-group",
                    {
                      model: {
                        value:
                          _vm.schoolConfigInSysResponse.attendanceDuplicate,
                        callback: function ($$v) {
                          _vm.$set(
                            _vm.schoolConfigInSysResponse,
                            "attendanceDuplicate",
                            $$v
                          )
                        },
                        expression:
                          "schoolConfigInSysResponse.attendanceDuplicate",
                      },
                    },
                    [
                      _c("el-radio", { attrs: { label: true } }, [
                        _vm._v("Có"),
                      ]),
                      _c("el-radio", { attrs: { label: false } }, [
                        _vm._v("Không"),
                      ]),
                    ],
                    1
                  ),
                ],
                1
              ),
            ]),
            _c("tr", [
              _c("td", { staticClass: "table-index" }, [_vm._v("86")]),
              _c("td", [
                _vm._v(
                  "Có áp dụng nhiều tài khoản ngân hàng cho 1 học sinh không?"
                ),
              ]),
              _c(
                "td",
                { staticClass: "table-action" },
                [
                  _c(
                    "el-radio-group",
                    {
                      model: {
                        value: _vm.schoolConfigInSysResponse.statusBank,
                        callback: function ($$v) {
                          _vm.$set(
                            _vm.schoolConfigInSysResponse,
                            "statusBank",
                            $$v
                          )
                        },
                        expression: "schoolConfigInSysResponse.statusBank",
                      },
                    },
                    [
                      _c("el-radio", { attrs: { label: true } }, [
                        _vm._v("Có"),
                      ]),
                      _c("el-radio", { attrs: { label: false } }, [
                        _vm._v("Không"),
                      ]),
                    ],
                    1
                  ),
                ],
                1
              ),
            ]),
            _c("tr", [
              _c("td", { staticClass: "table-index" }, [_vm._v("87")]),
              _vm._m(2),
              _c("td", { staticClass: "table-action" }, [
                _c("table", { staticClass: "center-table" }, [
                  _c("tr", [
                    _vm._v("Có gửi thông báo cho hoá đơn mới không ?"),
                  ]),
                  _c("tr", [
                    _c(
                      "td",
                      [
                        _c(
                          "el-radio-group",
                          {
                            model: {
                              value:
                                _vm.schoolConfigInSysResponse.statusOrderNew,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.schoolConfigInSysResponse,
                                  "statusOrderNew",
                                  $$v
                                )
                              },
                              expression:
                                "schoolConfigInSysResponse.statusOrderNew",
                            },
                          },
                          [
                            _c("el-radio", { attrs: { label: true } }, [
                              _vm._v("Có"),
                            ]),
                            _c("el-radio", { attrs: { label: false } }, [
                              _vm._v("Không"),
                            ]),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ]),
                  _c("tr", [
                    _c(
                      "td",
                      [
                        _c(
                          "el-row",
                          { attrs: { type: "flex", gutter: 24 } },
                          [
                            _c(
                              "el-col",
                              {
                                staticStyle: {
                                  "padding-top": "10px",
                                  "padding-bottom": "10px",
                                },
                                attrs: {
                                  span:
                                    _vm.schoolConfigInSysResponse
                                      .sendRepeatPlus &&
                                    !_vm.schoolConfigInSysResponse
                                      .statusOrderNew
                                      ? 12
                                      : 24,
                                },
                              },
                              [_vm._v("Ngày bắt đầu\n                    ")]
                            ),
                            _vm.schoolConfigInSysResponse.sendRepeatPlus &&
                            !_vm.schoolConfigInSysResponse.statusOrderNew
                              ? _c(
                                  "el-col",
                                  {
                                    staticStyle: {
                                      "padding-top": "10px",
                                      "padding-bottom": "10px",
                                    },
                                    attrs: { span: 12 },
                                  },
                                  [_vm._v("Bước nhảy\n                    ")]
                                )
                              : _vm._e(),
                          ],
                          1
                        ),
                        _c(
                          "el-row",
                          { attrs: { type: "flex", gutter: 24 } },
                          [
                            _c(
                              "el-col",
                              {
                                attrs: {
                                  span:
                                    _vm.schoolConfigInSysResponse
                                      .sendRepeatPlus &&
                                    !_vm.schoolConfigInSysResponse
                                      .statusOrderNew
                                      ? 12
                                      : 24,
                                },
                              },
                              [
                                _c(
                                  "el-input-number",
                                  {
                                    attrs: { size: "small" },
                                    model: {
                                      value:
                                        _vm.schoolConfigInSysResponse
                                          .dateSendPlus,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.schoolConfigInSysResponse,
                                          "dateSendPlus",
                                          $$v
                                        )
                                      },
                                      expression:
                                        "schoolConfigInSysResponse.dateSendPlus",
                                    },
                                  },
                                  [
                                    _vm._v(
                                      "\n                        >\n                      "
                                    ),
                                  ]
                                ),
                              ],
                              1
                            ),
                            _vm.schoolConfigInSysResponse.sendRepeatPlus &&
                            !_vm.schoolConfigInSysResponse.statusOrderNew
                              ? _c(
                                  "el-col",
                                  { attrs: { span: 12 } },
                                  [
                                    _c(
                                      "el-input-number",
                                      {
                                        attrs: { size: "small" },
                                        model: {
                                          value:
                                            _vm.schoolConfigInSysResponse
                                              .dateJumpPlus,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.schoolConfigInSysResponse,
                                              "dateJumpPlus",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "schoolConfigInSysResponse.dateJumpPlus",
                                        },
                                      },
                                      [
                                        _vm._v(
                                          "\n                        >\n                      "
                                        ),
                                      ]
                                    ),
                                  ],
                                  1
                                )
                              : _vm._e(),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ]),
                  !_vm.schoolConfigInSysResponse.statusOrderNew
                    ? _c("tr", [_vm._v("Cho phép gửi lặp lại không ?")])
                    : _vm._e(),
                  !_vm.schoolConfigInSysResponse.statusOrderNew
                    ? _c("tr", [
                        _c(
                          "td",
                          [
                            _c(
                              "el-radio-group",
                              {
                                model: {
                                  value:
                                    _vm.schoolConfigInSysResponse
                                      .sendRepeatPlus,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.schoolConfigInSysResponse,
                                      "sendRepeatPlus",
                                      $$v
                                    )
                                  },
                                  expression:
                                    "schoolConfigInSysResponse.sendRepeatPlus",
                                },
                              },
                              [
                                _c("el-radio", { attrs: { label: true } }, [
                                  _vm._v("Có"),
                                ]),
                                _c("el-radio", { attrs: { label: false } }, [
                                  _vm._v("Không"),
                                ]),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ])
                    : _vm._e(),
                  _c("tr", [
                    _c(
                      "td",
                      [
                        _c("span", [
                          _vm._v("Thông báo hoá đơn gói sắp hết hạn trước"),
                        ]),
                        _c(
                          "el-input-number",
                          {
                            staticStyle: { width: "110px" },
                            attrs: { size: "small" },
                            model: {
                              value: _vm.schoolConfigInSysResponse.datePlus,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.schoolConfigInSysResponse,
                                  "datePlus",
                                  $$v
                                )
                              },
                              expression: "schoolConfigInSysResponse.datePlus",
                            },
                          },
                          [
                            _vm._v(
                              "\n                    >\n                  "
                            ),
                          ]
                        ),
                        _c("span", { staticStyle: { "margin-left": "20px" } }, [
                          _vm._v("Ngày"),
                        ]),
                      ],
                      1
                    ),
                  ]),
                ]),
              ]),
            ]),
            _c("tr", [
              _c("td", { staticClass: "table-index" }, [_vm._v("88")]),
              _c("td", [
                _vm._v(
                  "Thiết lập cấu hình gửi thông báo gói học phí cho phụ huynh (App PHHS)"
                ),
              ]),
              _c("td", { staticClass: "table-action" }, [
                _c("table", { staticClass: "table-action" }, [
                  _c("tr", [
                    _c(
                      "td",
                      [
                        _c(
                          "span",
                          { staticStyle: { "margin-right": "20px" } },
                          [_vm._v("Ngày bắt đầu")]
                        ),
                        _c(
                          "el-input-number",
                          {
                            staticStyle: { width: "110px" },
                            attrs: { size: "small" },
                            model: {
                              value:
                                _vm.schoolConfigInSysResponse.dateSendParent,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.schoolConfigInSysResponse,
                                  "dateSendParent",
                                  $$v
                                )
                              },
                              expression:
                                "schoolConfigInSysResponse.dateSendParent",
                            },
                          },
                          [
                            _vm._v(
                              "\n                    >\n                  "
                            ),
                          ]
                        ),
                      ],
                      1
                    ),
                  ]),
                  _c("tr", [
                    _c(
                      "td",
                      [
                        _c(
                          "el-row",
                          { attrs: { type: "flex" } },
                          [
                            _c(
                              "el-col",
                              {
                                staticStyle: {
                                  "padding-top": "10px",
                                  "padding-bottom": "10px",
                                },
                                attrs: { span: 12 },
                              },
                              [_vm._v("Bước nhảy")]
                            ),
                            _c(
                              "el-col",
                              {
                                staticStyle: {
                                  "padding-top": "10px",
                                  "padding-bottom": "10px",
                                },
                                attrs: { span: 12 },
                              },
                              [_vm._v("Tần suất")]
                            ),
                          ],
                          1
                        ),
                        _c(
                          "el-row",
                          { attrs: { type: "flex" } },
                          [
                            _c(
                              "el-col",
                              { attrs: { span: 12 } },
                              [
                                _c(
                                  "el-input-number",
                                  {
                                    staticStyle: { width: "110px" },
                                    attrs: { size: "small" },
                                    model: {
                                      value:
                                        _vm.schoolConfigInSysResponse
                                          .dateJumpParent,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.schoolConfigInSysResponse,
                                          "dateJumpParent",
                                          $$v
                                        )
                                      },
                                      expression:
                                        "schoolConfigInSysResponse.dateJumpParent",
                                    },
                                  },
                                  [
                                    _vm._v(
                                      "\n                        >\n                      "
                                    ),
                                  ]
                                ),
                              ],
                              1
                            ),
                            _c(
                              "el-col",
                              { attrs: { span: 12 } },
                              [
                                _c(
                                  "el-input-number",
                                  {
                                    staticStyle: { width: "110px" },
                                    attrs: { size: "small" },
                                    model: {
                                      value:
                                        _vm.schoolConfigInSysResponse
                                          .dateFrequencyParent,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.schoolConfigInSysResponse,
                                          "dateFrequencyParent",
                                          $$v
                                        )
                                      },
                                      expression:
                                        "schoolConfigInSysResponse.dateFrequencyParent",
                                    },
                                  },
                                  [
                                    _vm._v(
                                      "\n                        >\n                      "
                                    ),
                                  ]
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ]),
                  _c("tr", [
                    _c(
                      "td",
                      [
                        _c("span", [
                          _vm._v("Thông báo hoá đơn gói sắp hết hạn trước"),
                        ]),
                        _c(
                          "el-input-number",
                          {
                            staticStyle: { width: "110px" },
                            attrs: { size: "small" },
                            model: {
                              value: _vm.schoolConfigInSysResponse.dateParent,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.schoolConfigInSysResponse,
                                  "dateParent",
                                  $$v
                                )
                              },
                              expression:
                                "schoolConfigInSysResponse.dateParent",
                            },
                          },
                          [
                            _vm._v(
                              "\n                    >\n                  "
                            ),
                          ]
                        ),
                        _c("span", { staticStyle: { "margin-left": "20px" } }, [
                          _vm._v("Ngày"),
                        ]),
                      ],
                      1
                    ),
                  ]),
                ]),
              ]),
            ]),
            _c("tr", [
              _c("td", { staticClass: "table-index" }, [_vm._v("89")]),
              _c("td", [
                _vm._v(
                  "Có tự động huỷ đăng kí gói học phí khi hết hạn hay không?"
                ),
              ]),
              _c(
                "td",
                { staticClass: "table-action" },
                [
                  _c(
                    "el-radio-group",
                    {
                      model: {
                        value: _vm.schoolConfigInSysResponse.autoCancelTuition,
                        callback: function ($$v) {
                          _vm.$set(
                            _vm.schoolConfigInSysResponse,
                            "autoCancelTuition",
                            $$v
                          )
                        },
                        expression:
                          "schoolConfigInSysResponse.autoCancelTuition",
                      },
                    },
                    [
                      _c("el-radio", { attrs: { label: true } }, [
                        _vm._v("Có"),
                      ]),
                      _c("el-radio", { attrs: { label: false } }, [
                        _vm._v("Không"),
                      ]),
                    ],
                    1
                  ),
                ],
                1
              ),
            ]),
            _c("tr", [
              _c("td", { staticClass: "table-index" }, [_vm._v("90")]),
              _c("td", [
                _vm._v("Có tự động điểm danh xin nghỉ đúng hạn hay không?"),
              ]),
              _c(
                "td",
                { staticClass: "table-action" },
                [
                  _c(
                    "el-radio-group",
                    {
                      model: {
                        value:
                          _vm.schoolConfigInSysResponse
                            .autoAttendanceLeaveOnTime,
                        callback: function ($$v) {
                          _vm.$set(
                            _vm.schoolConfigInSysResponse,
                            "autoAttendanceLeaveOnTime",
                            $$v
                          )
                        },
                        expression:
                          "schoolConfigInSysResponse.autoAttendanceLeaveOnTime",
                      },
                    },
                    [
                      _c("el-radio", { attrs: { label: true } }, [
                        _vm._v("Có"),
                      ]),
                      _c("el-radio", { attrs: { label: false } }, [
                        _vm._v("Không"),
                      ]),
                    ],
                    1
                  ),
                ],
                1
              ),
            ]),
            _c("tr", [
              _c("td", { staticClass: "table-index" }, [_vm._v("91")]),
              _c("td", [
                _vm._v(
                  "Có cho điểm danh khi có đơn xin nghỉ chưa xác nhận hay không?"
                ),
              ]),
              _c(
                "td",
                { staticClass: "table-action" },
                [
                  _c(
                    "el-row",
                    { attrs: { type: "flex" } },
                    [
                      _c(
                        "el-col",
                        {
                          staticStyle: { "padding-top": "10px" },
                          attrs: { span: 1 },
                        },
                        [_vm._v("Plus")]
                      ),
                      _c(
                        "el-col",
                        {
                          staticStyle: { "padding-top": "10px" },
                          attrs: { span: 23 },
                        },
                        [
                          _c(
                            "el-radio-group",
                            {
                              model: {
                                value:
                                  _vm.schoolConfigInSysResponse
                                    .applicationForLeave,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.schoolConfigInSysResponse,
                                    "applicationForLeave",
                                    $$v
                                  )
                                },
                                expression:
                                  "schoolConfigInSysResponse.applicationForLeave",
                              },
                            },
                            [
                              _c("el-radio", { attrs: { label: true } }, [
                                _vm._v("Có"),
                              ]),
                              _c("el-radio", { attrs: { label: false } }, [
                                _vm._v("Không"),
                              ]),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-row",
                    { attrs: { type: "flex" } },
                    [
                      _c(
                        "el-col",
                        {
                          staticStyle: { "padding-top": "10px" },
                          attrs: { span: 1 },
                        },
                        [_vm._v("Teacher")]
                      ),
                      _c(
                        "el-col",
                        {
                          staticStyle: { "padding-top": "10px" },
                          attrs: { span: 23 },
                        },
                        [
                          _c(
                            "el-radio-group",
                            {
                              model: {
                                value:
                                  _vm.schoolConfigInSysResponse
                                    .applicationForLeaveTeacher,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.schoolConfigInSysResponse,
                                    "applicationForLeaveTeacher",
                                    $$v
                                  )
                                },
                                expression:
                                  "schoolConfigInSysResponse.applicationForLeaveTeacher",
                              },
                            },
                            [
                              _c("el-radio", { attrs: { label: true } }, [
                                _vm._v("Có"),
                              ]),
                              _c("el-radio", { attrs: { label: false } }, [
                                _vm._v("Không"),
                              ]),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ]),
            _c("tr", [
              _c("td", { staticClass: "table-index" }, [_vm._v("92")]),
              _c("td", [
                _vm._v("Có tự động duyệt khi gửi điểm danh bằng mã QR không?"),
              ]),
              _c(
                "td",
                { staticClass: "table-action" },
                [
                  _c(
                    "el-row",
                    { attrs: { type: "flex" } },
                    [
                      _c(
                        "el-col",
                        {
                          staticStyle: { "padding-top": "10px" },
                          attrs: { span: 1 },
                        },
                        [_vm._v("Teacher")]
                      ),
                      _c(
                        "el-col",
                        {
                          staticStyle: { "padding-top": "10px" },
                          attrs: { span: 23 },
                        },
                        [
                          _c(
                            "el-radio-group",
                            {
                              model: {
                                value:
                                  _vm.schoolConfigInSysResponse
                                    .autoApproveRollCallByQrCode,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.schoolConfigInSysResponse,
                                    "autoApproveRollCallByQrCode",
                                    $$v
                                  )
                                },
                                expression:
                                  "schoolConfigInSysResponse.autoApproveRollCallByQrCode",
                              },
                            },
                            [
                              _c("el-radio", { attrs: { label: true } }, [
                                _vm._v("Có"),
                              ]),
                              _c("el-radio", { attrs: { label: false } }, [
                                _vm._v("Không"),
                              ]),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-row",
                    { attrs: { type: "flex" } },
                    [
                      _c(
                        "el-col",
                        {
                          staticStyle: { "padding-top": "10px" },
                          attrs: { span: 1 },
                        },
                        [_vm._v("Parent")]
                      ),
                      _c(
                        "el-col",
                        {
                          staticStyle: { "padding-top": "10px" },
                          attrs: { span: 23 },
                        },
                        [
                          _c(
                            "el-radio-group",
                            {
                              model: {
                                value:
                                  _vm.schoolConfigInSysResponse
                                    .autoApproveRollCallByQrCodeKid,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.schoolConfigInSysResponse,
                                    "autoApproveRollCallByQrCodeKid",
                                    $$v
                                  )
                                },
                                expression:
                                  "schoolConfigInSysResponse.autoApproveRollCallByQrCodeKid",
                              },
                            },
                            [
                              _c("el-radio", { attrs: { label: true } }, [
                                _vm._v("Có"),
                              ]),
                              _c("el-radio", { attrs: { label: false } }, [
                                _vm._v("Không"),
                              ]),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ]),
            _c("tr", [
              _c("td", { staticClass: "table-index" }, [_vm._v("93")]),
              _c("td", [
                _vm._v(
                  "Chọn buổi khi tự động chụp ảnh điểm danh đến bằng nhận diện mới?"
                ),
              ]),
              _c("td", { staticClass: "table-action" }, [
                _c(
                  "div",
                  { staticStyle: { "margin-top": "10px" } },
                  [
                    _c(
                      "el-checkbox",
                      {
                        model: {
                          value:
                            _vm.schoolConfigInSysResponse.takePictureMorning,
                          callback: function ($$v) {
                            _vm.$set(
                              _vm.schoolConfigInSysResponse,
                              "takePictureMorning",
                              $$v
                            )
                          },
                          expression:
                            "schoolConfigInSysResponse.takePictureMorning",
                        },
                      },
                      [_vm._v("\n                Sáng\n              ")]
                    ),
                    _c(
                      "el-checkbox",
                      {
                        model: {
                          value:
                            _vm.schoolConfigInSysResponse.takePictureAfternoon,
                          callback: function ($$v) {
                            _vm.$set(
                              _vm.schoolConfigInSysResponse,
                              "takePictureAfternoon",
                              $$v
                            )
                          },
                          expression:
                            "schoolConfigInSysResponse.takePictureAfternoon",
                        },
                      },
                      [_vm._v("\n                Chiều\n              ")]
                    ),
                    _c(
                      "el-checkbox",
                      {
                        model: {
                          value:
                            _vm.schoolConfigInSysResponse.takePictureEvening,
                          callback: function ($$v) {
                            _vm.$set(
                              _vm.schoolConfigInSysResponse,
                              "takePictureEvening",
                              $$v
                            )
                          },
                          expression:
                            "schoolConfigInSysResponse.takePictureEvening",
                        },
                      },
                      [_vm._v("\n                Tối\n              ")]
                    ),
                  ],
                  1
                ),
              ]),
            ]),
            _c("tr", [
              _c("td", { staticClass: "table-index" }, [_vm._v("96")]),
              _c("td", [
                _vm._v(
                  "Cho phép hiển thị link tới one-cam trên onekids(Parent) hay không?"
                ),
              ]),
              _c(
                "td",
                { staticClass: "table-action" },
                [
                  _c(
                    "el-radio-group",
                    {
                      model: {
                        value:
                          _vm.schoolConfigInSysResponse.showOneCamOnOnekids,
                        callback: function ($$v) {
                          _vm.$set(
                            _vm.schoolConfigInSysResponse,
                            "showOneCamOnOnekids",
                            $$v
                          )
                        },
                        expression:
                          "schoolConfigInSysResponse.showOneCamOnOnekids",
                      },
                    },
                    [
                      _c("el-radio", { attrs: { label: true } }, [
                        _vm._v("Có"),
                      ]),
                      _c("el-radio", { attrs: { label: false } }, [
                        _vm._v("Không"),
                      ]),
                    ],
                    1
                  ),
                ],
                1
              ),
            ]),
            _c("tr", [
              _c("td", { staticClass: "table-index" }, [_vm._v("97")]),
              _c("td", [
                _vm._v("Thời gian gọi lại xem album được tạo mới chưa?"),
              ]),
              _c(
                "td",
                { staticClass: "table-action" },
                [
                  _c(
                    "el-input-number",
                    {
                      staticStyle: { width: "110px" },
                      attrs: { size: "small" },
                      model: {
                        value:
                          _vm.schoolConfigInSysResponse.timeCallCreateAlbum,
                        callback: function ($$v) {
                          _vm.$set(
                            _vm.schoolConfigInSysResponse,
                            "timeCallCreateAlbum",
                            $$v
                          )
                        },
                        expression:
                          "schoolConfigInSysResponse.timeCallCreateAlbum",
                      },
                    },
                    [_vm._v("\n              >\n            ")]
                  ),
                  _c("span", { staticStyle: { "margin-left": "20px" } }, [
                    _vm._v("Giây"),
                  ]),
                ],
                1
              ),
            ]),
            _c("tr", [
              _c("td", { staticClass: "table-index" }, [_vm._v("98")]),
              _c("td", [
                _vm._v(
                  "Cho phép phát giọng nói khi có thông báo gửi đến hay không?"
                ),
              ]),
              _c(
                "td",
                { staticClass: "table-action" },
                [
                  _c(
                    "el-radio-group",
                    {
                      model: {
                        value:
                          _vm.schoolConfigInSysResponse.allowVoiceNotification,
                        callback: function ($$v) {
                          _vm.$set(
                            _vm.schoolConfigInSysResponse,
                            "allowVoiceNotification",
                            $$v
                          )
                        },
                        expression:
                          "schoolConfigInSysResponse.allowVoiceNotification",
                      },
                    },
                    [
                      _c("el-radio", { attrs: { label: true } }, [
                        _vm._v("Có"),
                      ]),
                      _c("el-radio", { attrs: { label: false } }, [
                        _vm._v("Không"),
                      ]),
                    ],
                    1
                  ),
                ],
                1
              ),
            ]),
            _c("tr", [
              _c("td", { staticClass: "table-index" }, [_vm._v("99")]),
              _c("td", [_vm._v("Số lần phát giọng nói khi có thông báo?")]),
              _c(
                "td",
                { staticClass: "table-action" },
                [
                  _c(
                    "el-input-number",
                    {
                      staticStyle: { width: "110px" },
                      attrs: { size: "small" },
                      model: {
                        value:
                          _vm.schoolConfigInSysResponse.numberVoiceNotification,
                        callback: function ($$v) {
                          _vm.$set(
                            _vm.schoolConfigInSysResponse,
                            "numberVoiceNotification",
                            $$v
                          )
                        },
                        expression:
                          "schoolConfigInSysResponse.numberVoiceNotification",
                      },
                    },
                    [_vm._v("\n              >\n            ")]
                  ),
                  _c("span", { staticStyle: { "margin-left": "20px" } }, [
                    _vm._v("Lần"),
                  ]),
                ],
                1
              ),
            ]),
            _c("tr", [
              _c("td", { staticClass: "table-index" }, [_vm._v("100")]),
              _c("td", [
                _vm._v("Thời gian giữa 2 lần phát giọng nói khi có thông báo?"),
              ]),
              _c(
                "td",
                { staticClass: "table-action" },
                [
                  _c(
                    "el-input-number",
                    {
                      staticStyle: { width: "110px" },
                      attrs: { size: "small" },
                      model: {
                        value:
                          _vm.schoolConfigInSysResponse
                            .timeBetweenTwoTimesVoice,
                        callback: function ($$v) {
                          _vm.$set(
                            _vm.schoolConfigInSysResponse,
                            "timeBetweenTwoTimesVoice",
                            $$v
                          )
                        },
                        expression:
                          "schoolConfigInSysResponse.timeBetweenTwoTimesVoice",
                      },
                    },
                    [_vm._v("\n              >\n            ")]
                  ),
                  _c("span", { staticStyle: { "margin-left": "20px" } }, [
                    _vm._v("Giây"),
                  ]),
                ],
                1
              ),
            ]),
            _c("tr", [
              _c("td", { staticClass: "table-index" }, [_vm._v("101")]),
              _c("td", [
                _vm._v("Hiện lựa chọn góp ý ẩn danh với App giáo viên?"),
              ]),
              _c(
                "td",
                { staticClass: "table-action" },
                [
                  _c(
                    "el-radio-group",
                    {
                      model: {
                        value: _vm.schoolConfigInSysResponse.appSuggestTeacher,
                        callback: function ($$v) {
                          _vm.$set(
                            _vm.schoolConfigInSysResponse,
                            "appSuggestTeacher",
                            $$v
                          )
                        },
                        expression:
                          "schoolConfigInSysResponse.appSuggestTeacher",
                      },
                    },
                    [
                      _c("el-radio", { attrs: { label: true } }, [
                        _vm._v("Có"),
                      ]),
                      _c("el-radio", { attrs: { label: false } }, [
                        _vm._v("Không"),
                      ]),
                    ],
                    1
                  ),
                ],
                1
              ),
            ]),
            _c("tr", [
              _c("td", { staticClass: "table-index" }, [_vm._v("102")]),
              _c("td", [
                _vm._v(
                  "Hiện lựa chọn góp ý ẩn danh với App phụ huynh học sinh?"
                ),
              ]),
              _c(
                "td",
                { staticClass: "table-action" },
                [
                  _c(
                    "el-radio-group",
                    {
                      model: {
                        value: _vm.schoolConfigInSysResponse.appSuggestParent,
                        callback: function ($$v) {
                          _vm.$set(
                            _vm.schoolConfigInSysResponse,
                            "appSuggestParent",
                            $$v
                          )
                        },
                        expression:
                          "schoolConfigInSysResponse.appSuggestParent",
                      },
                    },
                    [
                      _c("el-radio", { attrs: { label: true } }, [
                        _vm._v("Có"),
                      ]),
                      _c("el-radio", { attrs: { label: false } }, [
                        _vm._v("Không"),
                      ]),
                    ],
                    1
                  ),
                ],
                1
              ),
            ]),
            _c("tr", [
              _c("td", { staticClass: "table-index" }, [_vm._v("103")]),
              _c("td", [
                _vm._v("Hiển thị các thiết lập khác ở màn đăng nhập?"),
              ]),
              _c(
                "td",
                { staticClass: "table-action" },
                [
                  _c(
                    "el-radio-group",
                    {
                      model: {
                        value: _vm.schoolConfigInSysResponse.showVersion,
                        callback: function ($$v) {
                          _vm.$set(
                            _vm.schoolConfigInSysResponse,
                            "showVersion",
                            $$v
                          )
                        },
                        expression: "schoolConfigInSysResponse.showVersion",
                      },
                    },
                    [
                      _c("el-radio", { attrs: { label: true } }, [
                        _vm._v("Có"),
                      ]),
                      _c("el-radio", { attrs: { label: false } }, [
                        _vm._v("Không"),
                      ]),
                    ],
                    1
                  ),
                ],
                1
              ),
            ]),
            _c("tr", [
              _c("td", { staticClass: "table-index" }, [_vm._v("104")]),
              _c("td", [
                _vm._v(
                  "\n            Cho phép nhận xét ngày học sinh không cần điểm danh?\n          "
                ),
              ]),
              _c(
                "td",
                {
                  staticClass: "table-action",
                  staticStyle: { background: "white" },
                },
                [
                  _c(
                    "el-radio-group",
                    {
                      model: {
                        value:
                          _vm.schoolConfigInSysResponse
                            .commentsWithoutAttendance,
                        callback: function ($$v) {
                          _vm.$set(
                            _vm.schoolConfigInSysResponse,
                            "commentsWithoutAttendance",
                            $$v
                          )
                        },
                        expression:
                          "schoolConfigInSysResponse.commentsWithoutAttendance",
                      },
                    },
                    [
                      _c("el-radio", { attrs: { label: true } }, [
                        _vm._v("Có"),
                      ]),
                      _c("el-radio", { attrs: { label: false } }, [
                        _vm._v("Không"),
                      ]),
                    ],
                    1
                  ),
                ],
                1
              ),
            ]),
            _c("tr", [
              _c("td", { staticClass: "table-index" }, [_vm._v("105")]),
              _c("td", [
                _vm._v(
                  "\n            Bật âm thanh camera cho App Plus?\n          "
                ),
              ]),
              _c(
                "td",
                {
                  staticClass: "table-action",
                  staticStyle: { background: "white" },
                },
                [
                  _c(
                    "el-radio-group",
                    {
                      model: {
                        value: _vm.schoolConfigInSysResponse.openSoundAppPlus,
                        callback: function ($$v) {
                          _vm.$set(
                            _vm.schoolConfigInSysResponse,
                            "openSoundAppPlus",
                            $$v
                          )
                        },
                        expression:
                          "schoolConfigInSysResponse.openSoundAppPlus",
                      },
                    },
                    [
                      _c("el-radio", { attrs: { label: true } }, [
                        _vm._v("Có"),
                      ]),
                      _c("el-radio", { attrs: { label: false } }, [
                        _vm._v("Không"),
                      ]),
                    ],
                    1
                  ),
                ],
                1
              ),
            ]),
            _c("tr", [
              _c("td", { staticClass: "table-index" }, [_vm._v("106")]),
              _c("td", [
                _vm._v(
                  "\n            Hiển thị tổng tiền đã đóng và còn phải đóng (Học phí Excel)?\n          "
                ),
              ]),
              _c(
                "td",
                {
                  staticClass: "table-action",
                  staticStyle: { background: "white" },
                },
                [
                  _c(
                    "el-radio-group",
                    {
                      model: {
                        value:
                          _vm.schoolConfigInSysResponse.showTotalMoneyTuition,
                        callback: function ($$v) {
                          _vm.$set(
                            _vm.schoolConfigInSysResponse,
                            "showTotalMoneyTuition",
                            $$v
                          )
                        },
                        expression:
                          "schoolConfigInSysResponse.showTotalMoneyTuition",
                      },
                    },
                    [
                      _c("el-radio", { attrs: { label: true } }, [
                        _vm._v("Có"),
                      ]),
                      _c("el-radio", { attrs: { label: false } }, [
                        _vm._v("Không"),
                      ]),
                    ],
                    1
                  ),
                ],
                1
              ),
            ]),
            _c("tr", [
              _c("td", { staticClass: "table-index" }, [_vm._v("107")]),
              _c("td", [_vm._v("\n            Điểm danh version\n          ")]),
              _c(
                "td",
                {
                  staticClass: "table-action",
                  staticStyle: { background: "white" },
                },
                [
                  _c(
                    "el-select",
                    {
                      staticStyle: { width: "250px" },
                      attrs: { placeholder: "Chọn version" },
                      model: {
                        value:
                          _vm.schoolConfigInSysResponse.attendanceVersionConfig,
                        callback: function ($$v) {
                          _vm.$set(
                            _vm.schoolConfigInSysResponse,
                            "attendanceVersionConfig",
                            $$v
                          )
                        },
                        expression:
                          "schoolConfigInSysResponse.attendanceVersionConfig",
                      },
                    },
                    _vm._l(_vm.attendanceVersionConfigList, function (item) {
                      return _c("el-option", {
                        key: item.id,
                        attrs: { value: item.value, label: item.label },
                      })
                    }),
                    1
                  ),
                ],
                1
              ),
            ]),
            _c("tr", [
              _c("td", { staticClass: "table-index" }, [_vm._v("108")]),
              _c("td", [
                _vm._v(
                  "Có cho phép lựa chọn phiên bản giao diện Trang chủ không?"
                ),
              ]),
              _c(
                "td",
                { staticClass: "table-action" },
                [
                  _c(
                    "el-radio-group",
                    {
                      model: {
                        value:
                          _vm.schoolConfigInSysResponse
                            .allowSelectionInterfaceVersion,
                        callback: function ($$v) {
                          _vm.$set(
                            _vm.schoolConfigInSysResponse,
                            "allowSelectionInterfaceVersion",
                            $$v
                          )
                        },
                        expression:
                          "\n                schoolConfigInSysResponse.allowSelectionInterfaceVersion\n              ",
                      },
                    },
                    [
                      _c("el-radio", { attrs: { label: true } }, [
                        _vm._v("Có"),
                      ]),
                      _c("el-radio", { attrs: { label: false } }, [
                        _vm._v("Không"),
                      ]),
                    ],
                    1
                  ),
                ],
                1
              ),
            ]),
            _c("tr", [
              _c("td", { staticClass: "table-index" }, [_vm._v("109")]),
              _c("td", [
                _vm._v(
                  "\n            Phiên bản giao diện Trang chủ\n          "
                ),
              ]),
              _c(
                "td",
                {
                  staticClass: "table-action",
                  staticStyle: { background: "white" },
                },
                [
                  _c(
                    "el-select",
                    {
                      staticStyle: { width: "250px" },
                      attrs: { placeholder: "Chọn version" },
                      model: {
                        value:
                          _vm.schoolConfigInSysResponse
                            .homepageInterfaceVersion,
                        callback: function ($$v) {
                          _vm.$set(
                            _vm.schoolConfigInSysResponse,
                            "homepageInterfaceVersion",
                            $$v
                          )
                        },
                        expression:
                          "schoolConfigInSysResponse.homepageInterfaceVersion",
                      },
                    },
                    _vm._l(_vm.homepageInterfaceVersionList, function (item) {
                      return _c("el-option", {
                        key: item.id,
                        attrs: { value: item.value, label: item.label },
                      })
                    }),
                    1
                  ),
                ],
                1
              ),
            ]),
          ]),
        ]),
      ]),
      _c(
        "div",
        [
          _c(
            "el-button",
            {
              staticClass: "button-click",
              staticStyle: { "border-radius": "0" },
              attrs: {
                loading: _vm.loaddingButton,
                size: "medium",
                type: "success",
              },
              on: {
                click: function ($event) {
                  return _vm.submitConfigCommon()
                },
              },
            },
            [
              _c("i", { staticClass: "el-icon-circle-check" }),
              _c("span", [_vm._v("Lưu")]),
            ]
          ),
        ],
        1
      ),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("thead", [
      _c("tr", [
        _c("td", { staticClass: "table-index" }, [_vm._v("STT")]),
        _c("td", { staticStyle: { "text-align": "center" } }, [
          _vm._v("Nội dung"),
        ]),
        _c("td", { staticClass: "table-action" }, [_vm._v("Thiết lập")]),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("tr", [
      _c("td", { staticStyle: { "text-align": "center" } }, [
        _vm._v("Tin tức"),
      ]),
      _c("td", { staticStyle: { "text-align": "center" } }, [
        _vm._v("Facebook"),
      ]),
      _c("td", { staticStyle: { "text-align": "center" } }, [_vm._v("Video")]),
      _c("td", { staticStyle: { "text-align": "center" } }, [
        _vm._v("Website trường"),
      ]),
      _c("td", { staticStyle: { "text-align": "center" } }, [_vm._v("Tiktok")]),
      _c("td", { staticStyle: { "text-align": "center" } }, [
        _vm._v("Onekids Page"),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("td", [
      _c("div", [
        _vm._v(
          "\n              Thiết lập cấu hình gửi thông báo gói học phí cho nhà trường (App Plus được nhận)\n            "
        ),
      ]),
      _c("div", [
        _vm._v(
          '\n              Với hoá đơn hết hạn đăng kí thì Plus nhận được tin nhắn thông báo theo cấu hình "Cho phép gửi lặp lại\n              hay không ?"\n            '
        ),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }